// import React, {
//   useState,
//   useEffect,
//   useCallback,
//   useRef,
//   useMemo,
// } from "react";
// import { FaSearch } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import { Header } from "../../components/Header/Header";
// import UploadModal from "./UploadModal";
// import FilterModal from "./filterModal";
// import bell from "../../Images/ai-bell.png";
// import search from "../../Images/search-big.jpg";
// import axios from "axios";
// import "./contract_data.css";
// import Spinner from "./Spinner";
// import Cookies from "js-cookie";
// import api from "../chat/api";
// import CustomDropdown from "./CustomDropdown";
// import useGooglePicker from "../Ocr_Data/useGooglePicker";
// import { toast } from "react-toastify";
// const ContractTable = ({ isMenuOpen }) => {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isBulkDelete, setIsBulkDelete] = useState(false);
//   const [exportInProgress, setExportInProgress] = useState(false);
//   const [contracts, setContracts] = useState([]);
//   const [token, setToken] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [isActionMenuOpen, setIsActionMenuOpen] = useState(null);
//   const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
//   const [editContractId, setEditContractId] = useState(null);
//   const [editedContractData, setEditedContractData] = useState({});
//   const [loading, setLoading] = useState(false);
//   const editRowRef = useRef(null);
//   const [selectedContracts, setSelectedContracts] = useState([]);
//   const [selectedContractKeys, setSelectedContractKeys] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [popupVisible, setPopupVisible] = useState(false);
//   const [popupTitle, setPopupTitle] = useState("");
//   const [popupMessage, setPopupMessage] = useState("");
//   const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
//   const [contractToDelete, setContractToDelete] = useState(null);
//   const actionMenuRefs = useRef({});
//   const [hoveredRow, setHoveredRow] = useState(null);
//   const [isFilterApplied, setIsFilterApplied] = useState(false);
//   const fileInputRef = useRef(null);
//   const [hoveredAction, setHoveredAction] = useState(null);
//   const [clickedAction, setClickedAction] = useState(null);
//   const [filterApplied, setFilterApplied] = useState(false);
//   const [deleteInProgress, setDeleteInProgress] = useState(false);
//   const [renameSuccessRowId, setRenameSuccessRowId] = useState(null);
//   const [isCustomFieldModalOpen, setIsCustomFieldModalOpen] = useState(false);
//   const [isCustomApplyFieldModal, setIsCustomApplyFiledModal] = useState(false);
//   const [selectedTab, setSelectedTab] = useState("manage");
//   const [fieldName, setFieldName] = useState("");
//   const [fieldPrompt, setFieldPrompt] = useState("");
//   const [customFields, setCustomFields] = useState([]);
//   const [loadingAddField, setLoadingAddField] = useState(false);
//   const [customFieldsLoading, setCustomFieldsLoading] = useState(false);
//   const [deletingField, setDeletingField] = useState(null);
//   const isMaxFieldsReached = customFields.length >= 5;
//   const isFilled = fieldName.trim() && fieldPrompt.trim();
//   const [fieldCreationSuccess, setFieldCreationSuccess] = useState(false);
//   const moreButtonRef = useRef(null);
//   const [dropdownCoords, setDropdownCoords] = useState({ top: 0, left: 0 });
//   const [customFieldPopup, setCustomFieldPopup] = useState({
//     visible: false,
//     value: "",
//     contractKey: "",
//     contractId: "",
//     x: 0,
//     y: 0,
//   });
//   const popupRef = useRef(null);
//   const uploadButtonRef = useRef(null);
//   const [tooltipCoords, setTooltipCoords] = useState({ top: 0, left: 0 });
//   const { isConnected, connect, disconnect, openPicker, accessToken } =
//     useGooglePicker();
//   const [hasOpenedPickerOnce, setHasOpenedPickerOnce] = useState(false);
//   const [isHovered, setIsHovered] = useState(false);
//   const tbodyRef = useRef(null);

//   const baseColumns = 7; // name, party A, party B, date, etc.
//   const totalColumns = baseColumns + customFields.length;
//   const minWidthPercent = totalColumns * 15; // e.g., 9 * 15 = 135

//   const [isCreatingNew, setIsCreatingNew] = useState(false);
//   const [selectedField, setSelectedField] = useState("");
//   const [newFieldName, setNewFieldName] = useState("");
//   const [newPrompt, setNewPrompt] = useState("");
//   const [isLoading, setIsLoading] = useState(false);

//   const contractKeys = selectedContracts; // update as needed

//   useEffect(() => {
//     if (!isCreatingNew) {
//       fetch("/api/v1/contract/custom-fields/")
//         .then((res) => res.json())
//         .then((data) => setCustomFields(Array.isArray(data) ? data : []))
//         .catch((err) => {
//           setCustomFields([]); // fallback to empty array
//         });
//     }
//   }, [isCreatingNew]);

//   const handleApplyField = async () => {
//     setIsLoading(true);

//     const selectedFieldObj = customFields.find(
//       (field) => field.field === selectedField
//     );

//     const payload = isCreatingNew
//       ? {
//           new_field: {
//             field: newFieldName,
//             description: newPrompt,
//           },
//           contract_keys: selectedContractKeys,
//         }
//       : {
//           field_id: selectedFieldObj?.id, // ✅ send ID, not name
//           contract_keys: selectedContractKeys,
//         };

//     if (!isCreatingNew && !payload.field_id) {
//       console.error("Invalid field selected.");
//       setIsLoading(false);
//       return;
//     }

//     try {
//       const res = await api.post("api/v1/contract/apply-field/", payload);
//       setIsCustomApplyFiledModal(false);
//       await fetchContracts();
//       await fetchCustomFields();

//       setSelectedContracts([]);
//       setSelectedContractKeys([]);
//     } catch (err) {
//       console.error("Error:", err);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (isConnected && !hasOpenedPickerOnce) {
//       // Don't open picker here
//       setHasOpenedPickerOnce(true);
//     }
//   }, [isConnected, hasOpenedPickerOnce]);
//   const handleAddFromDriveClick = () => {
//     openPicker(async (docs) => {
//       console.log("📄 Files picked:", docs);

//       try {
//         const files = await Promise.all(
//           docs.map(async (doc) => {
//             const res = await fetch(
//               `https://www.googleapis.com/drive/v3/files/${doc.id}?alt=media`,
//               {
//                 headers: { Authorization: `Bearer ${accessToken}` },
//               }
//             );

//             if (!res.ok) throw new Error("Failed to fetch file from Drive");

//             const blob = await res.blob();
//             return new File([blob], doc.name, { type: blob.type });
//           })
//         );

//         setFile(files); // 👈 trigger your upload flow
//         setIsModalOpen(true); // 👈 open modal
//       } catch (err) {
//         console.error("Failed to process selected files", err);
//         toast.error("Something went wrong while processing selected files.");
//       }
//     });
//   };

//   const handleToggleMore = () => {
//     if (isActionMenuOpen === "more") {
//       setIsActionMenuOpen(null);
//     } else {
//       const rect = moreButtonRef.current.getBoundingClientRect();
//       setDropdownCoords({
//         top: rect.bottom + window.scrollY + 6, // Add spacing
//         left: rect.left + window.scrollX, // Align horizontally
//       });
//       setIsActionMenuOpen("more");
//     }
//   };

//   const isAllChecked =
//     selectedContracts.length === contracts.length && contracts.length > 0;

//   const navigate = useNavigate();
//   const handleFilterApply = (filteredContracts) => {
//     setContracts(filteredContracts);
//     setIsFilterApplied(true);
//     setFilterApplied(true);
//     toggleFilterModal();
//   };

//   useEffect(() => {
//     const cookieToken = Cookies.get("access_token");
//     if (cookieToken) {
//       setToken(cookieToken);
//     } else {
//       console.error("Access token missing from cookies");
//     }
//   }, []);

//   const toggleModal = () => {
//     setIsModalOpen((prev) => !prev);
//   };
//   const handleDeleteField = async (fieldId) => {
//     try {
//       await api.delete(`/api/v1/contract/delete-field/${fieldId}/`);
//       await fetchCustomFields(); // refresh after deletion
//     } catch (error) {
//       console.error("Error deleting field", error);
//     } finally {
//       setDeletingField(null);
//     }
//   };

//   const handleExport = async () => {
//     if (!selectedContracts || selectedContracts.length === 0) {
//       showPopup("Error", "Please select at least one contract to export.");
//       return;
//     }

//     setExportInProgress(true);

//     try {
//       const response = await api.post(
//         "api/v1/contract/export-file/",
//         { contract_keys: selectedContractKeys },
//         { responseType: "blob" }
//       );

//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", "contracts_export.csv");
//       document.body.appendChild(link);
//       link.click();
//     } catch (error) {
//       if (error.response) {
//         const message =
//           error.response.data.msg || "Failed to export contracts.";
//         showPopup("Error", message);
//       } else {
//         showPopup("Error", "An unexpected error occurred. Please try again.");
//       }
//     } finally {
//       setExportInProgress(false);
//       setSelectedContracts([]);
//       setSelectedContractKeys([]);
//     }
//   };

//   const fetchCustomFields = async () => {
//     try {
//       setCustomFieldsLoading(true);
//       const res = await api.get("/api/v1/contract/list-field/");
//       const data = res.data;

//       // Ensure it's an array before setting
//       setCustomFields(Array.isArray(data) ? data : []);
//     } catch (err) {
//       console.error("Error fetching fields", err);
//       setCustomFields([]); // fallback
//     } finally {
//       setCustomFieldsLoading(false);
//     }
//   };

//   const handleAddField = async () => {
//     if (!fieldName.trim() || !fieldPrompt.trim()) return;
//     try {
//       setLoadingAddField(true);
//       await api.post("/api/v1/contract/create-field/", {
//         field: fieldName.trim(),
//         description: fieldPrompt.trim(),
//       });

//       setFieldName("");
//       setFieldPrompt("");
//       await fetchCustomFields();

//       // show inline success message near button
//       setFieldCreationSuccess(true);
//       setTimeout(() => setFieldCreationSuccess(false), 5000);
//       setSelectedTab("manage");
//       setIsCustomFieldModalOpen(false);
//     } catch (error) {
//       console.error("Error adding field", error);
//     } finally {
//       setLoadingAddField(false);
//     }
//   };

//   const handleCancel = () => {
//     setSelectedContracts([]);

//     setIsModalOpen(false);
//     setIsFilterModalOpen(false);
//     setPopupVisible(false);

//     setConfirmDeleteVisible(false);
//   };

//   const fetchContracts = useCallback(async () => {
//     if (!token) return;
//     setLoading(true);

//     try {
//       const response = await api.get("api/v1/contract/contracts/");

//       setContracts(response.data);
//     } catch (error) {
//       console.error("Error fetching contracts:", error);
//     } finally {
//       setLoading(false);
//     }
//   }, [token]);

//   const tableBodyRef = useRef(null);

//   const scrollToTop = () => {
//     if (tableBodyRef.current) {
//       tableBodyRef.current.scrollTop = 0;
//     }
//   };

//   const handleSelectAll = () => {
//     if (selectedContracts.length === contracts.length) {
//       setSelectedContracts([]);
//       setSelectedContractKeys([]);
//     } else {
//       setSelectedContracts(contracts.map((contract) => contract.id));
//       setSelectedContractKeys(contracts.map((contract) => contract.key));
//     }
//   };

//   const filteredContracts = useMemo(() => {
//     const query = searchQuery.toLowerCase().trim();

//     if (!query) return contracts; // If search is empty, return all contracts

//     return contracts.filter((contract) => {
//       const contractName = contract.name?.toLowerCase() || "";
//       const ownerName = contract.details?.["Client name"]?.toLowerCase() || "";
//       const customerName =
//         contract.details?.["Company Name"]?.toLowerCase() || "";

//       return (
//         contractName.includes(query) ||
//         ownerName.includes(query) ||
//         customerName.includes(query)
//       );
//     });
//   }, [contracts, searchQuery]);

//   const indexOfLastContract = currentPage * rowsPerPage;
//   const indexOfFirstContract = indexOfLastContract - rowsPerPage;
//   const currentContracts = useMemo(() => {
//     const indexOfLastContract = currentPage * rowsPerPage;
//     const indexOfFirstContract = indexOfLastContract - rowsPerPage;
//     return filteredContracts.slice(indexOfFirstContract, indexOfLastContract);
//   }, [filteredContracts, currentPage, rowsPerPage]);

//   const totalPages = useMemo(
//     () => Math.ceil(filteredContracts.length / rowsPerPage),
//     [filteredContracts, rowsPerPage]
//   );
//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//     }
//   };

//   const handlePreviousPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };

//   const handleRowsPerPageChange = (event) => {
//     setRowsPerPage(Number(event.target.value));
//     setCurrentPage(1);
//   };

//   const handleCheckboxChange = (id, key) => {
//     if (selectedContracts.includes(id)) {
//       setSelectedContracts(
//         selectedContracts.filter((contractId) => contractId !== id)
//       );
//       setSelectedContractKeys(
//         selectedContractKeys.filter((contractKey) => contractKey !== key)
//       );
//     } else {
//       setSelectedContracts([...selectedContracts, id]);
//       setSelectedContractKeys([...selectedContractKeys, key]);
//     }
//   };

//   useEffect(() => {
//     if (token) {
//       fetchContracts();
//       fetchCustomFields();
//     }
//   }, [fetchContracts, token]);

//   const handleUploadSuccess = () => {
//     fetchContracts();
//     toggleModal();
//   };

//   const handleCloseModal = () => {
//     toggleModal();
//     fetchContracts();
//   };

//   const handlePageChange = (event) => {
//     const newPage = Number(event.target.value);
//     if (newPage > 0 && newPage <= totalPages) {
//       setCurrentPage(newPage);
//     }
//   };
//   const [actionMenuPosition, setActionMenuPosition] = useState({
//     top: 0,
//     left: 0,
//     openUpwards: false,
//   });

//   const toggleActionMenu = (index, event) => {
//     const menuHeight = 150; // Approximate height of the action menu
//     const rect = event.currentTarget.getBoundingClientRect();
//     const bottomSpace = window.innerHeight - rect.bottom;

//     const openUpwards = bottomSpace < menuHeight;

//     setIsActionMenuOpen(isActionMenuOpen === index ? null : index);
//     setActionMenuPosition({
//       top: openUpwards ? rect.top - menuHeight : rect.bottom,
//       left: rect.left,
//       openUpwards,
//     });
//   };

//   const toggleFilterModal = () => {
//     setIsFilterModalOpen((prev) => !prev);
//   };

//   const handleViewMore = (contractKey, id) => {
//     const condition = "table";
//     navigate(`/Contract/contract-details/${contractKey}`, {
//       state: { id }, // still send `id` in state if needed
//     });
//   };

//   const enableEdit = (contract) => {
//     if (contract) {
//       setIsActionMenuOpen(false);
//       setEditContractId(contract.id);
//       setEditedContractData({
//         ...contract, // Ensure all contract fields are copied
//         details: {
//           ...contract.details,
//           _custom_fields: contract.details?._custom_fields || {},
//           // Ensure existing contract details are copied
//         },
//       });
//     } else {
//       setEditContractId(null);
//       setEditedContractData({});
//     }
//   };

//   const handleEditChange = (field, value) => {
//     setEditedContractData((prev) => {
//       if (field.startsWith("details._custom_fields.")) {
//         const key = field.split(".")[2];
//         return {
//           ...prev,
//           details: {
//             ...prev.details,
//             _custom_fields: {
//               ...prev.details?._custom_fields,
//               [key]: value,
//             },
//           },
//         };
//       } else if (field.startsWith("details.")) {
//         const key = field.split(".")[1];
//         return {
//           ...prev,
//           details: {
//             ...prev.details,
//             [key]: value,
//           },
//         };
//       } else {
//         return {
//           ...prev,
//           [field]: value,
//         };
//       }
//     });
//   };

//   const handleClickOutside = (event) => {
//     if (
//       isActionMenuOpen !== null &&
//       actionMenuRefs.current[isActionMenuOpen] &&
//       !actionMenuRefs.current[isActionMenuOpen].contains(event.target)
//     ) {
//       setIsActionMenuOpen(null);
//     }

//     if (
//       confirmDeleteVisible &&
//       event.target.closest(".popup-overlay") === null &&
//       !event.target.closest(".popup-box-delete")
//     ) {
//       setConfirmDeleteVisible(false);
//     }
//   };

//   useEffect(() => {
//     const calculateRowsPerPage = () => {
//       if (tbodyRef.current) {
//         const containerHeight = tbodyRef.current.clientHeight;

//         const headerHeight = 52; // height of the <thead> row (approx)
//         const rowHeight = 44; // your row height from <tr className="h-[44px]">

//         const visibleHeight = containerHeight - headerHeight;
//         const calculatedRows = Math.floor(visibleHeight / rowHeight);

//         if (calculatedRows > 0) {
//           setRowsPerPage(calculatedRows);
//         }
//       }
//     };

//     calculateRowsPerPage(); // On mount

//     window.addEventListener("resize", calculateRowsPerPage); // On resize

//     return () => window.removeEventListener("resize", calculateRowsPerPage);
//   }, []);

//   useEffect(() => {
//     document.addEventListener("mousedown", handleClickOutside);

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [confirmDeleteVisible, isActionMenuOpen]);

//   const showPopup = (title, message) => {
//     setPopupTitle(title);
//     setPopupMessage(message);
//     setPopupVisible(true);
//   };

//   const closePopup = () => {
//     setPopupVisible(false);
//   };
//   const handleDelete = (contractId) => {
//     setIsActionMenuOpen(null);
//     setIsBulkDelete(false);
//     setContractToDelete(contractId);
//     setConfirmDeleteVisible(true);
//   };

//   const handleBulkDelete = () => {
//     if (!selectedContracts || selectedContracts.length === 0) {
//       showPopup("Error", "Please select at least one contract to delete.");
//       return;
//     }
//     setIsActionMenuOpen(null);
//     setIsBulkDelete(true);
//     setConfirmDeleteVisible(true);
//   };

//   const handleEditSave = async (contractId) => {
//     try {
//       const payload = {
//         edited_data: {
//           "Client name": editedContractData.details?.["Client name"],
//           "Company Name": editedContractData.details?.["Company Name"],
//           "Effective Date": editedContractData.details?.["Effective Date"],
//           "Renewal Date": editedContractData.details?.["Renewal Date"], // ✅ ADD THIS
//           "Expiration Date": editedContractData.details?.["Expiration Date"],
//           _custom_fields: editedContractData.details?._custom_fields || {},
//         },
//         note: editedContractData.note || "",
//         name: editedContractData.name || "",
//         contract_key: editedContractData.key, // make sure this is present
//       };

//       const response = await api.post(
//         `api/v1/contract/edit-contract-details/${editedContractData.key}/`,
//         {
//           edited_data: {
//             "Client name": editedContractData.details?.["Client name"],
//             "Company Name": editedContractData.details?.["Company Name"],
//             "Effective Date": editedContractData.details?.["Effective Date"],
//             "Renewal Date": editedContractData.details?.["Renewal Date"], // ✅ FIXED

//             "Expiration Date": editedContractData.details?.["Expiration Date"],
//             _custom_fields: editedContractData.details?._custom_fields || {},
//           },
//           note: editedContractData.note || "",
//           contract_name: editedContractData.name || "",
//         }
//       );

//       if (response.status === 200) {
//         const updatedContract = response.data;
//         setContracts((prevContracts) =>
//           prevContracts.map((contract) =>
//             contract.id === contractId ? updatedContract : contract
//           )
//         );
//         setEditContractId(null);
//         setRenameSuccessRowId(contractId); // Show success message only for that row

//         setTimeout(() => setRenameSuccessRowId(null), 4000);
//         fetchContracts(); // refresh full list if needed
//       }
//     } catch (error) {
//       console.error("Error saving contract:", error);
//       showPopup("Error", "Failed to update contract. Please try again.");
//     }
//   };

//   const confirmDelete = async () => {
//     const idsToDelete = isBulkDelete ? selectedContracts : [contractToDelete];

//     setDeleteInProgress(true);

//     try {
//       const response = await api.delete(`api/v1/contract/delete-contract/`, {
//         data: { contract_ids: idsToDelete },
//       });

//       const { Deleted_contracts = [], Failed_deletions = [] } = response.data;

//       if (Deleted_contracts.length > 0) {
//         setContracts((prevContracts) =>
//           prevContracts.filter(
//             (contract) => !Deleted_contracts.includes(contract.id)
//           )
//         );

//         if (isBulkDelete) setSelectedContracts([]);
//       }

//       if (Failed_deletions.length > 0) {
//         const failureMessages = Failed_deletions.map(
//           (failure) => `Contract ID ${failure.contract_id}: ${failure.error}`
//         ).join("\n");
//         showPopup("Deletion Failed", failureMessages);
//       }
//     } catch (error) {
//       console.error("Error deleting contracts:", error);
//       showPopup("Error", "Failed to delete contract(s). Please try again.");
//       setSelectedContracts([]);
//       setSelectedContractKeys([]);
//     } finally {
//       setDeleteInProgress(false);
//       setConfirmDeleteVisible(false);
//       setContractToDelete(null);
//       fetchContracts();
//       setSelectedContracts([]);
//       setSelectedContractKeys([]);
//     }
//   };

//   useEffect(() => {
//     if (editContractId) {
//       document.addEventListener("mousedown", handleClickOutside);
//     } else {
//       document.removeEventListener("mousedown", handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [editContractId]);

//   const formatDate = (dateString) => {
//     if (!dateString) return "";

//     const date = new Date(dateString);
//     if (isNaN(date.getTime())) return "";

//     const day = String(date.getDate()).padStart(2, "0");
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const year = date.getFullYear();

//     return `${day}-${month}-${year}`;
//   };

//   const toInputDateValue = (dateString) => {
//     const date = new Date(dateString);
//     if (isNaN(date.getTime())) return "";

//     // Prevent timezone offset issue by manually extracting parts
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const day = String(date.getDate()).padStart(2, "0");

//     return `${year}-${month}-${day}`; // yyyy-MM-dd
//   };

//   const [file, setFile] = useState(null);

//   const handleFileChange = (event) => {
//     const selectedFiles = Array.from(event.target.files || []);
//     if (selectedFiles.length === 0) return;

//     setFile(selectedFiles); // ✅ save to state
//     setIsModalOpen(true);
//   };

//   const [isSearchFocused, setIsSearchFocused] = useState(false);
//   const [isTooltipVisible, setIsTooltipVisible] = useState(false);

//   return (
//     <>
//       {loading && <Spinner />}
//       <div className="full-container max-w-full overflow-x-hidden">
//         <div className="">
//           <Header name="Contracts" icon={""} isMenuOpen={isMenuOpen} />
//         </div>

//         <div
//           className="contract-table-container relative overflow-x-hidden"
//           style={{ marginLeft: isMenuOpen ? "226px" : "120px" }}
//         >
//           <div className="flex justify-between items-center contract-table-header overflow-x-hidden w-full pr-9 mt-[2px]">
//             {/* LEFT: Search & Filter */}
//             <div className="flex items-center gap-1 min-w-[300px]">
//               {/* Search */}
//               <div
//                 style={{
//                   display: "flex",
//                   width: "310px",
//                   height: "40px",
//                   padding: "8px 20px 8px 26px",
//                   alignItems: "center",
//                   gap: "1px",
//                   flexShrink: 0,
//                   borderRadius: "20px",
//                   border: isSearchFocused
//                     ? "1px solid rgba(187, 66, 174, 0.36)"
//                     : "1px solid rgba(0, 0, 0, 0.10)",
//                   backgroundColor: "#FFF",
//                   boxShadow: isSearchFocused
//                     ? "0px 11px 3px rgba(0, 0, 0, 0.00), 0px 7px 3px rgba(0, 0, 0, 0.01), 0px 4px 2px rgba(0, 0, 0, 0.05), 0px 2px 2px rgba(0, 0, 0, 0.09), 0px 0px 1px rgba(0, 0, 0, 0.10)"
//                     : "none",
//                   overflow: "hidden",
//                 }}
//               >
//                 <img
//                   src="/search.svg"
//                   alt="Search"
//                   style={{ width: "24px", height: "24px", marginRight: "4px" }}
//                 />
//                 <input
//                   type="text"
//                   placeholder="Search Contracts Here"
//                   value={searchQuery}
//                   onChange={(e) => setSearchQuery(e.target.value)}
//                   onFocus={() => setIsSearchFocused(true)}
//                   onBlur={() => setIsSearchFocused(false)}
//                   style={{
//                     fontFamily: "Outfit, sans-serif",
//                     fontSize: "14px",
//                     fontWeight: 400,
//                     border: "none",
//                     outline: "none",
//                     width: "100%",
//                     overflowX: "auto",
//                     whiteSpace: "nowrap",
//                     color: "#171717",
//                   }}
//                 />
//               </div>

//               {/* Filter */}
//               <button
//                 className={`filter-button-new ${
//                   isFilterApplied ? "filter-applieds" : ""
//                 }`}
//                 onClick={toggleFilterModal}
//               >
//                 <img
//                   src={isFilterApplied ? "/Filter_CTA.png" : "/filter.svg"}
//                   alt="Filter Icon"
//                 />
//               </button>
//             </div>

//             {/* RIGHT SIDE ACTIONS */}
//             <div className="flex items-center gap-3 flex-wrap justify-end">
//               {selectedContracts.length > 0 ? (
//                 <>
//                   <span className="bg-[#F4EBFF] text-[#7F56D9] text-sm px-3 py-1 rounded-full font-medium">
//                     {selectedContracts.length} Contracts selected
//                   </span>

//                   <button
//                     className="bg-[#7F56D9] text-white text-sm font-medium px-4 py-2 rounded-md hover:bg-[#6941C6] transition"
//                     onClick={() => setIsCustomApplyFiledModal(true)}
//                   >
//                     <span className="text-white">Apply Custom Field</span>
//                   </button>

//                   {/* More Dropdown */}
//                   <div className="relative">
//                     <button
//                       ref={moreButtonRef}
//                       onClick={handleToggleMore}
//                       className="border border-[#D0D5DD] text-[#344054] text-sm font-medium px-4 py-2 rounded-md flex items-center gap-2 hover:bg-gray-50"
//                     >
//                       More
//                       <svg
//                         className="w-4 h-4"
//                         fill="none"
//                         stroke="currentColor"
//                         strokeWidth={2}
//                         viewBox="0 0 24 24"
//                       >
//                         <path d="M19 9l-7 7-7-7" />
//                       </svg>
//                     </button>

//                     {isActionMenuOpen === "more" && (
//                       <div
//                         className="fixed z-[9999] w-35 bg-white border border-gray-200 rounded-md shadow-md py-1 p-1"
//                         style={{
//                           top: `${dropdownCoords.top}px`,
//                           left: `${dropdownCoords.left}px`,
//                         }}
//                       >
//                         <button
//                           onClick={handleExport}
//                           disabled={exportInProgress}
//                           className="flex items-center gap-2 px-3 py-2 text-sm rounded-md w-full hover:bg-purple-100 text-[#8B55DD] disabled:opacity-50"
//                         >
//                           <img
//                             src="/export-icon-blue.svg"
//                             className="w-4 h-4"
//                           />
//                           {exportInProgress ? "Exporting..." : "Export"}
//                         </button>

//                         <button
//                           onClick={handleBulkDelete}
//                           className="flex items-center gap-2 px-3 py-2 text-sm rounded-md w-full hover:bg-red-100 text-red-600"
//                         >
//                           <img src="/delete-icon-red.svg" className="w-4 h-4" />
//                           Delete
//                         </button>
//                       </div>
//                     )}
//                   </div>

//                   {/* Cancel */}
//                   <button onClick={handleCancel} className="ml-2">
//                     <img
//                       src="/cancel_icon.svg"
//                       alt="Cancel"
//                       className="w-5 h-5"
//                     />
//                   </button>
//                 </>
//               ) : (
//                 <>
                  // <button
                  //   className="flex items-center gap-2 px-4 py-2 bg-white new-custom-butons-design"
                  //   onClick={() => setIsCustomFieldModalOpen(true)}
                  // >
                  //   <img src="/custom-field-icons.svg" className="w-5 h-5" />
                  //   <span className="new-custom-butons-design-text">
                  //     Custom Field
                  //   </span>
                  // </button>

//                   {/* Upload Button + Tooltip */}
//                   <div className="relative">
//                     <button
//                       ref={uploadButtonRef}
//                       className="flex items-center gap-2 px-4 py-2 bg-[#C95EBE] rounded-md text-white text-sm hover:bg-[#B34AB0]"
//                       onClick={() => setIsTooltipVisible(!isTooltipVisible)}
//                       onMouseEnter={() => {
//                         if (uploadButtonRef.current) {
//                           const rect =
//                             uploadButtonRef.current.getBoundingClientRect();
//                           setTooltipCoords({
//                             top: rect.top + window.scrollY + 45,
//                             left: rect.left + window.scrollX + rect.width - 140,
//                           });
//                         }
//                       }}
//                     >
//                       <img src="/upload_icon_white.svg" className="w-5 h-5" />
//                       <span className="new-custom-butons-design-texts">
//                         Upload Contract
//                       </span>
//                     </button>

//                     {/* Tooltip */}
//                     {isTooltipVisible && (
//                       <div
//                         className="fixed z-[9999] w-[188px] h-[102px] flex flex-col justify-center items-start gap-2 p-[10px] bg-white border border-black/20 rounded-[12px] shadow-[90px_417px_119px_rgba(0,0,0,0),58px_267px_109px_rgba(0,0,0,0.01),33px_150px_92px_rgba(0,0,0,0.05),14px_67px_68px_rgba(0,0,0,0.09),4px_17px_38px_rgba(0,0,0,0.10)]"
//                         style={{
//                           top: `${tooltipCoords.top + 10}px`,
//                           left: `${tooltipCoords.left - 50}px`,
//                         }}
//                         onMouseLeave={() => setIsTooltipVisible(false)}
//                       >
//                         {/* Upload from Device */}
//                         <div
//                           className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
//                           onClick={() => {
//                             setIsTooltipVisible(false);
//                             fileInputRef.current.click();
//                           }}
//                         >
//                           <img
//                             src="/upload-icon.svg"
//                             alt="Upload"
//                             className="w-4 h-4"
//                           />
//                           Add from device
//                         </div>

//                         {/* Connect Google Drive */}
//                         {!isConnected && (
//                           <div
//                             className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
//                             onClick={() => {
//                               setIsTooltipVisible(false);
//                               navigate("/account/integration");
//                             }}
//                             onMouseEnter={() => setIsHovered(true)}
//                             onMouseLeave={() => setIsHovered(false)}
//                           >
//                             <img
//                               src={
//                                 isHovered
//                                   ? "/connect-icon-hover.svg"
//                                   : "/connect-icon.svg"
//                               }
//                               alt="Open Picker"
//                               className="w-4 h-4 transition-all duration-150"
//                             />{" "}
//                             Connect Drive
//                           </div>
//                         )}

//                         {/* File Picker if connected */}
//                         {isConnected && (
//                           <div
//                             className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
//                             onMouseEnter={() => setIsHovered(true)}
//                             onMouseLeave={() => setIsHovered(false)}
//                             onClick={handleAddFromDriveClick} // Trigger the picker on click
//                           >
//                             <img
//                               src={
//                                 isHovered
//                                   ? "/picker-icon-hover.svg"
//                                   : "/picker-icon.svg"
//                               }
//                               alt="Open Picker"
//                               className="w-4 h-4 transition-all duration-150"
//                             />
//                             Add from Drive
//                           </div>
//                         )}
//                       </div>
//                     )}

//                     <input
//                       ref={fileInputRef}
//                       type="file"
//                       multiple
//                       className="hidden"
//                       accept=".pdf,.jpeg,.jpg,.png"
//                       onChange={handleFileChange}
//                     />
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>

//           <div
//             className={`overflow-x-auto  transition-all duration-300 mt-2`}
//             style={{
//               width: isMenuOpen ? "calc(100vw - 320px)" : "calc(100vw - 158px)",
//             }}
//           >
//             <div className="overflow-x-auto w-[100%]  mb-4">
//               <div
//                 className="relative overflow-x-auto  custom-scrollbar-container"
//                 style={{
//                   height: "calc(100vh - 180px)", // Adjust height as needed
//                 }}
//                 ref={tbodyRef}
//               >
//                 <table
//                   className="text-sm text-left table-auto"
//                   style={{ minWidth: `${totalColumns * 14.26}%` }}
//                 >
//                   <thead className="bg-[#FFF] h-[51px] text-[#1E1E1E] font-medium border-b border-[rgba(0,0,0,0.10)]">
//                     <tr>
//                       <th className="w-[40px] px-3">
//                         <input
//                           type="checkbox"
//                           className="custom-checkbox"
//                           style={{
//                             appearance: "none",
//                             // width: "16px",
//                             // height: "16px",
//                             border: "1.5px solid #c0c0c0",
//                             borderRadius: "4px",
//                             cursor: "pointer",
//                             backgroundImage: isAllChecked
//                               ? "url('/checck.svg')"
//                               : "none",
//                             backgroundPosition: "center",
//                             backgroundRepeat: "no-repeat",
//                             backgroundSize: "20px 20px",
//                           }}
//                           onChange={handleSelectAll}
//                           checked={isAllChecked}
//                         />
//                       </th>
//                       {/* <th>Contract ID</th> */}
//                       <th className="w-[150px] px-1 file-size-of-heading">
//                         Contract Name
//                       </th>
//                       <th className="w-[150px] px-3 file-size-of-heading">
//                         Party Involved (A)
//                       </th>
//                       <th className="w-[150px] px-3 file-size-of-heading">
//                         Party Involved (B)
//                       </th>
//                       <th className="w-[120px] px-3 file-size-of-heading">
//                         Effective Date
//                       </th>

//                       {customFields.map((field, index) => (
//                         <th
//                           key={index}
//                           className="w-[150px] px-3 file-size-of-headings"
//                         >
//                           <span className="inline-flex items-baseline gap-1">
//                             {field.field}{" "}
//                             <img
//                               src="/invoice-bulblogo-invoicee.svg"
//                               alt="Bullet Icon"
//                               className="ml-1 translate-y-[-2px]" // slightly lifted
//                             />
//                           </span>
//                         </th>
//                       ))}
//                       <th className="w-[140px] px-3 file-size-of-heading">
//                         Renewal Date
//                       </th>
//                       <th className="w-[120px] px-3 file-size-of-heading">
//                         Expiration Date
//                       </th>
//                       <th className="w-[100px] px-3 file-size-of-heading">
//                         Actions
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody
//                     className={
//                       currentContracts.length > rowsPerPage ? "scrollable" : ""
//                     }
//                     style={{
//                       overflowY:
//                         currentContracts.length > rowsPerPage
//                           ? "auto"
//                           : "hidden",
//                       maxHeight: "400px",
//                       backgroundColor: "#FFF",
//                     }}
//                   >
//                     {loading ? (
//                       <tr>
//                         <td colSpan="6" style={{ textAlign: "center" }}>
//                           <Spinner />
//                         </td>
//                       </tr>
//                     ) : contracts.length > 0 ? (
//                       currentContracts.map((contract, index) => (
//                         <tr
//                           key={index}
//                           ref={
//                             editContractId === contract.id ? editRowRef : null
//                           }
//                           style={{
//                             background:
//                               hoveredRow === index ? "#F8F3FF" : "transparent",
//                             boxShadow:
//                               hoveredRow === index
//                                 ? "0px 2px 4px 0px rgba(0, 0, 0, 0.25)"
//                                 : "none",
//                           }}
//                           onMouseEnter={() => setHoveredRow(index)}
//                           onMouseLeave={() => setHoveredRow(null)}
//                           className="h-[44px] border-b border-[rgba(0,0,0,0.10)] hover:bg-gray-50 transition"
//                         >
//                           <td className="px-3">
//                             <input
//                               type="checkbox"
//                               className="custom-checkbox"
//                               style={{
//                                 appearance: "none",
//                                 // width: "16px",
//                                 // height: "16px",
//                                 border: "1.5px solid #c0c0c0",
//                                 borderRadius: "4px",
//                                 cursor: "pointer",
//                                 backgroundImage: selectedContracts.includes(
//                                   contract.id
//                                 )
//                                   ? "url('/checck.svg')"
//                                   : "none",
//                                 backgroundPosition: "center",
//                                 backgroundRepeat: "no-repeat",
//                                 backgroundSize: "20px 20px",
//                               }}
//                               checked={selectedContracts.includes(contract.id)}
//                               onChange={() =>
//                                 handleCheckboxChange(contract.id, contract.key)
//                               }
//                             />
//                           </td>

//                           {editContractId === contract.id ? (
//                             <>
//                               <td className="file-size-of-subheading">
//                                 <input
//                                   type="text"
//                                   value={editedContractData.name || ""}
//                                   onChange={(e) =>
//                                     handleEditChange("name", e.target.value)
//                                   }
//                                   className="edit-contract-custom-two"
//                                   style={{ color: "#B793ED" }}
//                                 />
//                               </td>
//                               <td className="file-size-of-subheading">
//                                 <input
//                                   type="text"
//                                   value={
//                                     editedContractData.details?.[
//                                       "Client name"
//                                     ] || ""
//                                   }
//                                   onChange={(e) =>
//                                     handleEditChange(
//                                       "details.Client name",
//                                       e.target.value
//                                     )
//                                   }
//                                   className="edit-contract-custom-one"
//                                 />
//                               </td>

//                               <td className="file-size-of-subheading">
//                                 <input
//                                   type="text"
//                                   value={
//                                     editedContractData.details?.[
//                                       "Company Name"
//                                     ] ??
//                                     contract.details?.["Company Name"] ??
//                                     ""
//                                   }
//                                   onChange={(e) =>
//                                     handleEditChange(
//                                       "details.Company Name",
//                                       e.target.value
//                                     )
//                                   }
//                                   className="edit-contract-custom-one"
//                                 />
//                               </td>
//                               <td className="file-size-of-subheading">
//                                 <input
//                                   type="date"
//                                   value={
//                                     editedContractData.details?.[
//                                       "Effective Date"
//                                     ]
//                                       ? toInputDateValue(
//                                           editedContractData.details?.[
//                                             "Effective Date"
//                                           ]
//                                         )
//                                       : ""
//                                   }
//                                   onChange={(e) =>
//                                     handleEditChange(
//                                       "details.Effective Date",
//                                       e.target.value
//                                     )
//                                   }
//                                   className="edit-contract"
//                                 />
//                               </td>

//                               {customFields.map((fieldObj, index) => {
//                                 const fieldKey = fieldObj.field;
//                                 return (
//                                   <td
//                                     key={index}
//                                     className="file-size-of-subheading"
//                                   >
//                                     <input
//                                       type="text"
//                                       value={
//                                         editedContractData.details
//                                           ?._custom_fields?.[fieldKey] || ""
//                                       }
//                                       onChange={(e) =>
//                                         handleEditChange(
//                                           `details._custom_fields.${fieldKey}`,
//                                           e.target.value
//                                         )
//                                       }
//                                       className="edit-contract"
//                                     />
//                                   </td>
//                                 );
//                               })}

//                               <td className="file-size-of-subheading">
//                                 <input
//                                   type="date"
//                                   value={
//                                     editedContractData.details?.["Renewal Date"]
//                                       ? toInputDateValue(
//                                           editedContractData.details?.[
//                                             "Renewal Date"
//                                           ]
//                                         )
//                                       : ""
//                                   }
//                                   onChange={(e) =>
//                                     handleEditChange(
//                                       "details.Renewal Date",
//                                       e.target.value
//                                     )
//                                   }
//                                   className="edit-contract"
//                                 />
//                               </td>

//                               <td className="file-size-of-subheading">
//                                 <input
//                                   type="date"
//                                   value={
//                                     editedContractData.details?.[
//                                       "Expiration Date"
//                                     ]
//                                       ? toInputDateValue(
//                                           editedContractData.details?.[
//                                             "Expiration Date"
//                                           ]
//                                         )
//                                       : ""
//                                   }
//                                   onChange={(e) =>
//                                     handleEditChange(
//                                       "details.Expiration Date",
//                                       e.target.value
//                                     )
//                                   }
//                                   className="edit-contract"
//                                 />
//                               </td>
//                               <td className="action-icons-contract">
//                                 <button
//                                   onClick={() => handleEditSave(contract.id)}
//                                   className="icon-button-contract"
//                                 >
//                                   <img
//                                     src="/save-icon-contracttable.svg"
//                                     alt="Save"
//                                     className="action-icon"
//                                   />
//                                 </button>
//                                 <button
//                                   onClick={() => setEditContractId(null)}
//                                   className="icon-button-contract"
//                                 >
//                                   <img
//                                     src="/cancel-icon-contracttable.svg"
//                                     alt="Cancel"
//                                     className="action-icon"
//                                   />
//                                 </button>
//                               </td>
//                             </>
//                           ) : (
//                             <>
//                               <td className="px-1 file-size-of-subheading">
//                                 <span
//                                   className="tooltip-wrapper"
//                                   style={{
//                                     color: "#B793ED",
//                                     textDecoration: "none",
//                                     cursor: "pointer",
//                                     borderBottom: "1.5px solid #B793ED",
//                                     paddingBottom: "2px",
//                                   }}
//                                   onClick={() =>
//                                     handleViewMore(contract.key, contract.id)
//                                   }
//                                 >
//                                   {contract.name?.length > 30
//                                     ? `${contract.name.slice(
//                                         0,
//                                         50
//                                       )}...${contract.name.slice(-5)}`
//                                     : contract.name || "N/A"}
//                                   <span className="tooltip-text">
//                                     {contract.name || "N/A"}
//                                   </span>
//                                   {renameSuccessRowId === contract.id && (
//                                     <div
//                                       className="inline-flex p-2"
//                                       style={{
//                                         width: "205px",
//                                         height: "32px",
//                                         borderRadius: "8px",
//                                         border: "1px solid rgba(0, 0, 0, 0.10)",
//                                         background: "#FFF",
//                                         boxShadow:
//                                           "0px 11px 3px rgba(0, 0, 0, 0.00), 0px 7px 3px rgba(0, 0, 0, 0.01), 0px 4px 2px rgba(0, 0, 0, 0.05), 0px 2px 2px rgba(0, 0, 0, 0.09), 0px 0px 1px rgba(0, 0, 0, 0.10)",
//                                         position: "absolute",
//                                         marginLeft: "4rem",
//                                         zIndex: 10,
//                                       }}
//                                     >
//                                       <img
//                                         src="/green-icon-tick.svg"
//                                         alt="Success"
//                                         style={{
//                                           width: "20px",
//                                           height: "20px",
//                                         }}
//                                       />
//                                       <span
//                                         style={{
//                                           color: "#52525B",
//                                           fontFamily: "Outfit",
//                                           fontSize: "13px",
//                                           fontStyle: "normal",
//                                           fontWeight: 400,
//                                           letterSpacing: "-0.26px",
//                                         }}
//                                       >
//                                         Your changes were applied
//                                       </span>
//                                     </div>
//                                   )}
//                                 </span>
//                               </td>
//                               <td className="px-3 file-size-of-subheading">
//                                 <span
//                                   className="tooltip-wrapper"
//                                   style={{
//                                     textDecoration: "none",
//                                     cursor: "pointer",
//                                   }}
//                                 >
//                                   {contract.details?.["Client name"]?.length >
//                                   25
//                                     ? `${contract.details["Client name"].slice(
//                                         0,
//                                         20
//                                       )}...${contract.details[
//                                         "Client name"
//                                       ].slice(-5)}`
//                                     : contract.details?.["Client name"] ||
//                                       "N/A"}
//                                   <span className="tooltip-text">
//                                     {contract.details?.["Client name"] || "N/A"}
//                                   </span>
//                                 </span>
//                               </td>

//                               <td className="px-3 file-size-of-subheading">
//                                 <span
//                                   className="tooltip-wrapper"
//                                   style={{
//                                     textDecoration: "none",
//                                     cursor: "pointer",
//                                   }}
//                                 >
//                                   {contract.details?.["Company Name"]?.length >
//                                   25
//                                     ? `${contract.details["Company Name"].slice(
//                                         0,
//                                         20
//                                       )}...${contract.details[
//                                         "Company Name"
//                                       ].slice(-5)}`
//                                     : contract.details?.["Company Name"] ||
//                                       "N/A"}
//                                   <span className="tooltip-text">
//                                     {contract.details?.["Company Name"] ||
//                                       "N/A"}
//                                   </span>
//                                 </span>
//                               </td>

//                               <td className="px-3 file-size-of-subheading">
//                                 <span
//                                   className="tooltip-wrapper"
//                                   style={{
//                                     textDecoration: "none",
//                                     cursor: "pointer",

//                                     paddingBottom: "2px",
//                                   }}
//                                 >
//                                   {contract.details?.["Effective Date"]
//                                     ? formatDate(
//                                         contract.details["Effective Date"]
//                                       )
//                                     : "N/A"}
//                                 </span>
//                               </td>

//                               {customFields.map((fieldObj, index) => {
//                                 const fieldKey = fieldObj.field; // actual key used in _custom_fields
//                                 const fieldValue =
//                                   contract.details?._custom_fields?.[
//                                     fieldKey
//                                   ] || "N/A";
//                                 const isValid =
//                                   fieldValue && fieldValue !== "null";

//                                 return (
//                                   <td
//                                     key={index}
//                                     className="px-3 file-size-of-subheadin"
//                                   >
//                                     <span
//                                       className="text-[#B793ED] cursor-pointer inline-block max-w-[140px] truncate"
//                                       onMouseEnter={(e) => {
//                                         const rect =
//                                           e.currentTarget.getBoundingClientRect();
//                                         setCustomFieldPopup({
//                                           visible: true,
//                                           value: fieldValue,
//                                           contractKey: contract.key,
//                                           contractId: contract.id,
//                                           x: rect.left + window.scrollX,
//                                           y: rect.bottom + window.scrollY + 8,
//                                         });
//                                       }}
//                                       onMouseLeave={(e) => {
//                                         // Start timeout that allows user to move to popup
//                                         setTimeout(() => {
//                                           if (
//                                             popupRef.current &&
//                                             !popupRef.current.matches(":hover")
//                                           ) {
//                                             setCustomFieldPopup((prev) => ({
//                                               ...prev,
//                                               visible: false,
//                                             }));
//                                           }
//                                         }, 150);
//                                       }}
//                                     >
//                                       {fieldValue.length > 10
//                                         ? `${fieldValue.slice(0, 10)}...`
//                                         : fieldValue}
//                                     </span>
//                                   </td>
//                                 );
//                               })}

//                               <td className="px-3 file-size-of-subheading">
//                                 {contract.details?.["Renewal Date"] &&
//                                 contract.details?.["Renewal Date"] !== "null"
//                                   ? formatDate(contract.details["Renewal Date"])
//                                   : "N/A"}
//                               </td>

//                               <td className="px-3 file-size-of-subheading">
//                                 {contract.details?.["Expiration Date"]
//                                   ? formatDate(
//                                       contract.details?.["Expiration Date"]
//                                     )
//                                   : "N/A"}
//                               </td>

//                               <td className="px-3 file-size-of-subheading">
//                                 <img
//                                   src="./action.svg"
//                                   alt="Actions"
//                                   width="20"
//                                   height="20"
//                                   onClick={(e) => toggleActionMenu(index, e)}
//                                   style={{ cursor: "pointer" }}
//                                 />
//                                 {isActionMenuOpen === index && (
//                                   <div
//                                     className="action-menu"
//                                     style={{
//                                       position: "fixed",
//                                       top: actionMenuPosition.openUpwards
//                                         ? `${actionMenuPosition.top}px`
//                                         : `${actionMenuPosition.top}px`,
//                                       left: `${
//                                         actionMenuPosition.left - 215
//                                       }px`,
//                                       transform: actionMenuPosition.openUpwards
//                                         ? "translateY(50%)"
//                                         : "none", // If openUpwards, shift the menu upward
//                                       zIndex: 9999,
//                                     }}
//                                     ref={(el) => {
//                                       if (el)
//                                         actionMenuRefs.current[index] = el;
//                                     }}
//                                   >
//                                     <div
//                                       className="action-item"
//                                       onMouseEnter={() =>
//                                         setHoveredAction("edit")
//                                       }
//                                       onMouseLeave={() =>
//                                         setHoveredAction(null)
//                                       }
//                                       onMouseDown={() =>
//                                         setClickedAction("edit")
//                                       }
//                                       onMouseUp={() => setClickedAction(null)}
//                                       onClick={() => enableEdit(contract)}
//                                       style={{
//                                         color:
//                                           clickedAction === "edit"
//                                             ? "#C95EBE"
//                                             : hoveredAction === "edit"
//                                             ? "#C95EBE"
//                                             : "",
//                                         transition: "color 0.2s ease-in-out",
//                                         borderRadius: "8px",
//                                         border:
//                                           clickedAction === "edit" ||
//                                           hoveredAction === "edit"
//                                             ? "none"
//                                             : "none",
//                                         background:
//                                           clickedAction === "edit" ||
//                                           hoveredAction === "edit"
//                                             ? "#FAF9F6"
//                                             : "transparent",
//                                       }}
//                                     >
//                                       <img
//                                         src={
//                                           clickedAction === "edit"
//                                             ? "./edit-active-contract.svg"
//                                             : hoveredAction === "edit"
//                                             ? "./edit-active-contract.svg"
//                                             : "./edit.svg"
//                                         }
//                                         alt="Edit Icon"
//                                         className="action-icon"
//                                       />
//                                       <p>Edit</p>
//                                     </div>
//                                     <div
//                                       className="action-item"
//                                       onMouseEnter={() =>
//                                         setHoveredAction("delete")
//                                       }
//                                       onMouseLeave={() =>
//                                         setHoveredAction(null)
//                                       }
//                                       onMouseDown={() =>
//                                         setClickedAction("delete")
//                                       }
//                                       onMouseUp={() => setClickedAction(null)}
//                                       onClick={() => handleDelete(contract.id)}
//                                       style={{
//                                         color:
//                                           clickedAction === "delete"
//                                             ? "var(--reeedd, rgba(226, 25, 25, 0.75))"
//                                             : hoveredAction === "delete"
//                                             ? "var(--reeedd, rgba(226, 25, 25, 0.75))"
//                                             : "",
//                                         transition: "color 0.2s ease-in-out",
//                                         borderRadius: "8px",
//                                         border:
//                                           clickedAction === "delete" ||
//                                           hoveredAction === "delete"
//                                             ? "none"
//                                             : "none",
//                                         background:
//                                           clickedAction === "delete" ||
//                                           hoveredAction === "delete"
//                                             ? "#FAF9F6"
//                                             : "transparent",
//                                       }}
//                                     >
//                                       <img
//                                         src={
//                                           clickedAction === "delete"
//                                             ? "./delete-active-contract.svg"
//                                             : hoveredAction === "delete"
//                                             ? "./delete-active-contract.svg"
//                                             : "./delete.svg"
//                                         }
//                                         alt="Delete Icon"
//                                         className="action-icon"
//                                       />
//                                       <p>Delete</p>
//                                     </div>
//                                   </div>
//                                 )}
//                               </td>
//                             </>
//                           )}
//                         </tr>
//                       ))
//                     ) : (
//                       <tr className="h-[44px] text-center">
//                         <td colSpan="7" className="py-6 text-black-400">
//                           <img
//                             src="/no-contracts.svg"
//                             alt="No Data"
//                             className="mx-auto mb-2"
//                           />
//                           <p className="text-[16px]">
//                             Looks like your table is empty!
//                           </p>
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//               {contracts.length > 0 && (
//                 <div className="pagination-doc mt-2">
//                   <div className="pagination-dropdown">
//                     <p className="page-selector">{currentPage}</p>
//                   </div>
//                   <p className="contentDown">of {totalPages} pages</p>
//                   <button
//                     onClick={handlePreviousPage}
//                     disabled={currentPage === 1}
//                     style={{
//                       cursor: currentPage === 1 ? "not-allowed" : "pointer",
//                     }}
//                   >
//                     <img
//                       src="decrease.svg"
//                       alt="Previous Page"
//                       style={{ height: "12px", width: "12px" }}
//                     />
//                   </button>
//                   <button
//                     onClick={handleNextPage}
//                     disabled={currentPage === totalPages}
//                     style={{
//                       cursor:
//                         currentPage === totalPages ? "not-allowed" : "pointer",
//                     }}
//                   >
//                     <img
//                       src="increase.svg"
//                       alt="Next Page"
//                       style={{ height: "12px", width: "12px" }}
//                     />
//                   </button>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>

//         {popupVisible && (
//           <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
//             <div className="popup-box">
//               <h2>{popupTitle}</h2>
//               <p>{popupMessage}</p>
//               <button onClick={closePopup} className="popup-close-button">
//                 Close
//               </button>
//             </div>
//           </div>
//         )}

//         {confirmDeleteVisible && (
//           <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
//             <div className="popup-box-delete">
//               <h2>Are you sure you want to delete the selected spreadsheet?</h2>
//               <p>
//                 {isBulkDelete
//                   ? "Once deleted, the selected item(s) will be permanently removed.This action cannot be undone."
//                   : "Once deleted, the selected item(s) will be permanently removed.This action cannot be undone."}
//               </p>
//               <div
//                 style={{
//                   display: "flex",
//                   gap: "8px",
//                   justifyContent: "center",
//                   marginTop: "20px",
//                 }}
//               >
//                 <button
//                   onClick={() => setConfirmDeleteVisible(false)}
//                   disabled={deleteInProgress}
//                   className="document-popup-close-delete"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={confirmDelete}
//                   disabled={deleteInProgress}
//                   className="document-popup-close-button"
//                 >
//                   {deleteInProgress ? "Deleting..." : "Delete"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//         <UploadModal
//           isOpen={isModalOpen}
//           onClose={handleCloseModal}
//           onUploadSuccess={handleUploadSuccess}
//           type={"contract"}
//           file={file}
//         />

//         <FilterModal
//           isOpen={isFilterModalOpen}
//           onClose={() => setIsFilterModalOpen(false)}
//           token={token}
//           setContracts={(filteredContracts) => {
//             setContracts(filteredContracts);
//             setIsFilterModalOpen(false);
//             setIsFilterApplied(true);
//           }}
//           fetchContracts={fetchContracts}
//           setIsFilterApplied={setIsFilterApplied}
//         />
//         {isCustomFieldModalOpen && (
//           <div className="custom-modal-overlay-inline show">
//             <div className="custom-modal-content-custom active relative">
//               <button
//                 className="close-modal-custom"
//                 onClick={() => setIsCustomFieldModalOpen(false)}
//               >
//                 ×
//               </button>

//               <h2 className="custom-modal-title-custom">Custom Fields</h2>
//               <p className="custom-modal-subtitle-custom">
//                 You can only create up to 5 custom fields per document.
//                 <br />
//                 Deleting a field won’t reset the limit.
//               </p>

//               <div className="custom-modal-tabs-custom">
//                 <button
//                   className={`manage-btn-custom ${
//                     selectedTab === "manage" ? "active" : ""
//                   }`}
//                   onClick={() => setSelectedTab("manage")}
//                 >
//                   {customFieldsLoading
//                     ? "Loading..."
//                     : `Manage Existing Fields (${customFields.length}/5)`}
//                 </button>
//                 <button
//                   className={`create-btn-custom ${
//                     selectedTab === "create" ? "active" : ""
//                   }`}
//                   onClick={() => setSelectedTab("create")}
//                 >
//                   Create New Field
//                 </button>
//               </div>

//               {selectedTab === "create" && (
//                 <>
//                   <label className="field-label-custom">
//                     Field name{" "}
//                     <img
//                       src="/bulb.svg"
//                       alt="Hint"
//                       className="label-icon-custom"
//                     />
//                   </label>
//                   <input
//                     type="text"
//                     className="input-field-custom"
//                     value={fieldName}
//                     onChange={(e) => setFieldName(e.target.value)}
//                     placeholder={
//                       isMaxFieldsReached
//                         ? "Maximum 5 fields allowed. Please delete one to add new."
//                         : "Enter your field name here"
//                     }
//                     disabled={isMaxFieldsReached}
//                   />
//                   <label className="field-label-custom">
//                     Extraction Prompt{" "}
//                     <img
//                       src="/bulb.svg"
//                       alt="Hint"
//                       className="label-icon-custom"
//                     />
//                   </label>
//                   <textarea
//                     className="textarea-field-custom"
//                     value={fieldPrompt}
//                     onChange={(e) => setFieldPrompt(e.target.value)}
//                     placeholder={
//                       isMaxFieldsReached
//                         ? "Cannot enter prompt. Maximum limit reached."
//                         : "Enter your Extraction Prompts here"
//                     }
//                     disabled={isMaxFieldsReached}
//                   />
//                   <button
//                     className={`add-field-btn-custom ${
//                       isFilled && !loadingAddField && !isMaxFieldsReached
//                         ? "active"
//                         : ""
//                     }`}
//                     onClick={handleAddField}
//                     disabled={loadingAddField || isMaxFieldsReached}
//                   >
//                     {loadingAddField ? "Adding..." : "Add Field"}
//                   </button>
//                 </>
//               )}

//               {selectedTab === "manage" && (
//                 <div>
//                   <div className="manage-fields-placeholder mt-[20px] max-h-[222px] overflow-y-auto mr-2">
//                     <div className="flex mt-2 gap-[60px]">
//                       <h2 className="field-name-custom">Field Name</h2>
//                       <h2 className="field-name-custom">Prompt</h2>
//                     </div>
//                     {customFields.length ? (
//                       customFields.map((field, index) => (
//                         <div key={index}>
//                           <div className="flex items-start gap-[26px] mt-[12px]">
//                             <p className="text-[#1A1A1A] text-sm font-medium w-[100px] break-words">
//                               {field.field}
//                             </p>

//                             <p className="text-[#1A1A1A] text-sm w-[139px]">
//                               {field.description}
//                             </p>
//                             <button
//                               className="button-red-custom-field"
//                               onClick={() => {
//                                 setDeletingField(field.id);
//                                 handleDeleteField(field.id);
//                               }}
//                               disabled={deletingField === field.id}
//                             >
//                               {deletingField === field.id
//                                 ? "Deleting"
//                                 : "Delete"}
//                               <img src="/delete-icon-red.svg" alt="Delete" />
//                             </button>
//                           </div>
//                           <div className="my-4 mt-[20px] border-[#EAEAEA] hr-line-divider"></div>
//                         </div>
//                       ))
//                     ) : (
//                       <p className="text-sm text-gray-500 ml-2 mt-3">
//                         No custom fields available.
//                       </p>
//                     )}
//                   </div>

//                   <button
//                     className="add-field-btn-custom-twos absolute bottom-4 right-4"
//                     onClick={async () => {
//                       await fetchContracts(); // refresh table to show new field
//                       setIsCustomFieldModalOpen(false);
//                     }}
//                   >
//                     Done
//                   </button>
//                 </div>
//               )}
//             </div>
//           </div>
//         )}
//         {fieldCreationSuccess && (
//           <div
//             className="success-popup inline-flex items-center p-4 bg-white border border-gray-200 shadow-sm rounded-md text-sm text-gray-700 fixed z-[100]"
//             style={{
//               top: "50%",
//               left: "50%",
//               transform: "translate(-50%, -50%)",
//             }}
//           >
//             <img src="/green-icon-tick.svg" className="mr-2" alt="Success" />
//             Field Created successfully, Select documents to apply this field
//           </div>
//         )}

//         {isCustomApplyFieldModal && (
//           <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
//             <div
//               className="relative bg-white rounded-[12px] shadow-lg w-[417px] h-[366px] pt-[18px] pl-[24px] pr-[24px] pb-[24px]"
//               style={{
//                 boxShadow:
//                   "130px 189px 64px rgba(0, 0, 0, 0.00), 83px 121px 59px rgba(0, 0, 0, 0.01), 47px 68px 50px rgba(0, 0, 0, 0.05), 21px 30px 37px rgba(0, 0, 0, 0.09), 5px 8px 20px rgba(0, 0, 0, 0.10)",
//               }}
//             >
              // <div className="flex justify-between items-center">
              //   <h2 className="apply-heading-cutom">Apply Custom Field</h2>
              //   <span className="text-[#8B55DD] bg-[rgba(139,85,221,0.08)] text-[14px] rounded px-3 py-1">
              //     {selectedContracts.length} Contracts selected
              //   </span>
              //   <span
              //     onClick={() => setIsCustomApplyFiledModal(false)}
              //     className="cursor-pointer text-xl"
              //   >
              //     ×
              //   </span>
              // </div>

//               <div className="flex gap-8 mt-[20px] items-start">
//                 {/* Option 1: Select Existing */}
//                 <label className="flex items-center gap-2 cursor-pointer">
//                   <input
//                     type="radio"
//                     checked={!isCreatingNew}
//                     onChange={() => setIsCreatingNew(false)}
//                     className="accent-[#7F56D9] w-4 h-4"
//                   />
//                   <span className="apply-dot-heading">
//                     Select from Existing Field
//                   </span>
//                 </label>

//                 {/* Option 2: Create New Field + (2/5 used) below it */}
//                 <label className="flex flex-col cursor-pointer">
//                   <div className="flex items-center gap-2">
//                     <input
//                       type="radio"
//                       checked={isCreatingNew}
//                       onChange={() => setIsCreatingNew(true)}
//                       className="accent-[#7F56D9] w-4 h-4"
//                     />
//                     <span className="apply-dot-heading">Create New Field</span>
//                   </div>
//                   <span className="text-xs text-[#999] ml-6">
//                     ({customFields.length}/5 used)
//                   </span>
//                 </label>
//               </div>

//               {isCreatingNew ? (
//                 <>
//                   <label className="apply-dot-heading">Field Name</label>
//                   <input
//                     className="apply-input-field pl-2 mt-1"
//                     placeholder="Enter your field name here"
//                     value={newFieldName}
//                     onChange={(e) => setNewFieldName(e.target.value)}
//                   />
//                   <label className="apply-dot-heading mt-2">
//                     Extraction Prompt
//                   </label>
//                   <textarea
//                     className="apply-input-field-design-here pl-2 pt-1 pr-1 mt-1"
//                     placeholder="Enter your Extraction Prompts here"
//                     value={newPrompt}
//                     onChange={(e) => setNewPrompt(e.target.value)}
//                   />
//                 </>
//               ) : (
//                 <>
//                   <label className="apply-dot-heading">Choose Field</label>
//                   <CustomDropdown
//                     selected={selectedField}
//                     onSelect={setSelectedField}
//                     options={customFields.map((field) => field.field)}
//                   />
//                 </>
//               )}

//               <div className="absolute bottom-4 right-4 flex justify-end gap-3">
//                 <button
//                   className="cancel-apply-button-design"
//                   onClick={() => setIsCustomApplyFiledModal(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={handleApplyField}
//                   className={`apply-apply-button ${
//                     isLoading
//                       ? "bg-[#D081D9]"
//                       : "bg-[#D081D9] hover:bg-[#C26ED2]"
//                   }`}
//                 >
//                   {isLoading ? (
//                     <span className="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
//                   ) : isCreatingNew ? (
//                     "Create & Apply"
//                   ) : (
//                     "Apply Field"
//                   )}
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//         {customFieldPopup.visible && (
//           <div
//             ref={popupRef}
//             className="fixed z-[9999] bg-white border border-gray-300 rounded-md shadow-md p-3"
//             style={{
//               top: `${customFieldPopup.y}px`,
//               left: `${customFieldPopup.x - 30}px`,
//               maxWidth: "300px",
//               width: "max-content",
//               whiteSpace: "normal",
//             }}
//             onMouseEnter={() =>
//               setCustomFieldPopup((prev) => ({ ...prev, visible: true }))
//             }
//             onMouseLeave={() =>
//               setCustomFieldPopup((prev) => ({ ...prev, visible: false }))
//             }
//           >
//             <p className="text-gray-800 text-sm font-medium break-words">
//               {customFieldPopup.value.length > 40
//                 ? `${customFieldPopup.value.slice(0, 40)}...`
//                 : customFieldPopup.value}
//             </p>
//             <button
//               onClick={() =>
//                 handleViewMore(
//                   customFieldPopup.contractKey,
//                   customFieldPopup.contractId
//                 )
//               }
//               className="text-[#6F42C1] text-sm font-semibold underline mt-2 hover:text-[#4c2a8a]"
//             >
//               View More
//             </button>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default ContractTable;
/* global google */
/* global gapi */
import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "../../components/Header/Header";
import UploadModal from "./UploadModal";
import FilterModal from "./filterModal";
import CustomDropdown from "./CustomDropdown";
import useGooglePicker from "../Ocr_Data/useGooglePicker";
import Cookies from "js-cookie";
import api from "../chat/api";
import { toast } from "../../utils/appToast";
import "./contract_data.css";

const ContractTable = ({ isMenuOpen }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBulkDelete, setIsBulkDelete] = useState(false);
  const [exportInProgress, setExportInProgress] = useState(false);
  const [contracts, setContracts] = useState([]);
  const [token, setToken] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isActionMenuOpen, setIsActionMenuOpen] = useState(null);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [editContractId, setEditContractId] = useState(null);
  const [editedContractData, setEditedContractData] = useState({});
  const [loading, setLoading] = useState(false);
  const editRowRef = useRef(null);
  const [selectedContracts, setSelectedContracts] = useState([]);
  const [selectedContractKeys, setSelectedContractKeys] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [popupMessage, setPopupMessage] = useState("");
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
  const [contractToDelete, setContractToDelete] = useState(null);
  const actionMenuRefs = useRef({});
  const [hoveredRow, setHoveredRow] = useState(null);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const fileInputRef = useRef(null);
  const [hoveredAction, setHoveredAction] = useState(null);
  const [clickedAction, setClickedAction] = useState(null);
  const [filterApplied, setFilterApplied] = useState(false);
  const [deleteInProgress, setDeleteInProgress] = useState(false);
  const [renameSuccessRowId, setRenameSuccessRowId] = useState(null);
  const [isCustomFieldModalOpen, setIsCustomFieldModalOpen] = useState(false);
  const [isCustomApplyFieldModal, setIsCustomApplyFiledModal] = useState(false);
  const [selectedTab, setSelectedTab] = useState("manage");
  const [fieldName, setFieldName] = useState("");
  const [fieldPrompt, setFieldPrompt] = useState("");
  const [customFields, setCustomFields] = useState([]);
  const [loadingAddField, setLoadingAddField] = useState(false);
  const [customFieldsLoading, setCustomFieldsLoading] = useState(false);
  const [deletingField, setDeletingField] = useState(null);
  const isMaxFieldsReached = customFields.length >= 5;
  const isFilled = fieldName.trim() && fieldPrompt.trim();
  const [fieldCreationSuccess, setFieldCreationSuccess] = useState(false);
  const moreButtonRef = useRef(null);
  const [dropdownCoords, setDropdownCoords] = useState({ top: 0, left: 0 });
  const [customFieldPopup, setCustomFieldPopup] = useState({ visible: false, value: "", contractKey: "", contractId: "", x: 0, y: 0 });
  const popupRef = useRef(null);
  const uploadButtonRef = useRef(null);
  const [tooltipCoords, setTooltipCoords] = useState({ top: 0, left: 0 });
  const { isConnected, openPicker, accessToken } = useGooglePicker();
  const [hasOpenedPickerOnce, setHasOpenedPickerOnce] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const tbodyRef = useRef(null);
  const tableBodyRef = useRef(null);
  const [file, setFile] = useState(null);
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const baseColumns = 7;
  const totalColumns = baseColumns + customFields.length;
  const minWidthPercent = totalColumns * 14.26;

  const [isCreatingNew, setIsCreatingNew] = useState(false);
  const [selectedField, setSelectedField] = useState("");
  const [newFieldName, setNewFieldName] = useState("");
  const [newPrompt, setNewPrompt] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const cookieToken = Cookies.get("access_token");
    if (cookieToken) setToken(cookieToken);
  }, []);

  const fetchContracts = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    try {
      const response = await api.get("api/v1/contract/contracts/");
      setContracts(response.data);
    } catch (error) {
      console.error("Error fetching contracts:", error);
    } finally {
      setLoading(false);
    }
  }, [token]);

  const fetchCustomFields = async () => {
    try {
      setCustomFieldsLoading(true);
      const res = await api.get("/api/v1/contract/list-field/");
      setCustomFields(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      setCustomFields([]);
    } finally {
      setCustomFieldsLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      fetchContracts();
      fetchCustomFields();
    }
  }, [fetchContracts, token]);

  useEffect(() => {
    if (!isCreatingNew && token) {
      fetchCustomFields();
    }
  }, [isCreatingNew, token]);

  useEffect(() => {
    if (isConnected && !hasOpenedPickerOnce) setHasOpenedPickerOnce(true);
  }, [isConnected, hasOpenedPickerOnce]);

  const handleApplyField = async () => {
    setIsLoading(true);
    const selectedFieldObj = customFields.find((field) => field.field === selectedField);

    const payload = isCreatingNew
      ? { new_field: { field: newFieldName, description: newPrompt }, contract_keys: selectedContractKeys }
      : { field_id: selectedFieldObj?.id, contract_keys: selectedContractKeys };

    if (!isCreatingNew && !payload.field_id) {
      setIsLoading(false);
      return;
    }

    try {
      await api.post("api/v1/contract/apply-field/", payload);
      setIsCustomApplyFiledModal(false);
      await fetchContracts();
      await fetchCustomFields();
      setSelectedContracts([]);
      setSelectedContractKeys([]);
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddFromDriveClick = () => {
    openPicker(async (docs) => {
      try {
        const files = await Promise.all(
          docs.map(async (doc) => {
            const res = await fetch(`https://www.googleapis.com/drive/v3/files/${doc.id}?alt=media`, { headers: { Authorization: `Bearer ${accessToken}` } });
            if (!res.ok) throw new Error("Failed to fetch file from Drive");
            const blob = await res.blob();
            return new File([blob], doc.name, { type: blob.type });
          })
        );
        setFile(files);
        setIsModalOpen(true);
      } catch (err) {
        toast.error("Something went wrong while processing selected files.");
      }
    });
  };
  const handleUploadSuccess = () => {
    fetchContracts();
    toggleModal();
  };

  const handleCloseModal = () => {
    toggleModal();
    fetchContracts();
  };
  const handleToggleMore = () => {
    if (isActionMenuOpen === "more") {
      setIsActionMenuOpen(null);
    } else {
      const rect = moreButtonRef.current.getBoundingClientRect();
      setDropdownCoords({ top: rect.bottom + 6, left: rect.left });
      setIsActionMenuOpen("more");
    }
  };

  const toggleModal = () => setIsModalOpen((prev) => !prev);
  const toggleFilterModal = () => setIsFilterModalOpen((prev) => !prev);

  const showPopup = (title, message) => {
    setPopupTitle(title);
    setPopupMessage(message);
    setPopupVisible(true);
  };

  const closePopup = () => setPopupVisible(false);

  const handleCancel = () => {
    setSelectedContracts([]);
    setSelectedContractKeys([]);
    setIsModalOpen(false);
    setIsFilterModalOpen(false);
    setPopupVisible(false);
    setConfirmDeleteVisible(false);
  };

  const handleDeleteField = async (fieldId) => {
    try {
      await api.delete(`/api/v1/contract/delete-field/${fieldId}/`);
      await fetchCustomFields();
    } catch (error) {
      console.error("Error deleting field", error);
    } finally {
      setDeletingField(null);
    }
  };

  const handleExport = async () => {
    if (!selectedContracts || selectedContracts.length === 0) return;
    setExportInProgress(true);
    try {
      const response = await api.post("api/v1/contract/export-file/", { contract_keys: selectedContractKeys }, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "contracts_export.csv");
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      showPopup("Error", error.response?.data?.msg || "Failed to export contracts.");
    } finally {
      setExportInProgress(false);
      setSelectedContracts([]);
      setSelectedContractKeys([]);
    }
  };

  const handleAddField = async () => {
    if (!fieldName.trim() || !fieldPrompt.trim()) return;
    try {
      setLoadingAddField(true);
      await api.post("/api/v1/contract/create-field/", { field: fieldName.trim(), description: fieldPrompt.trim() });
      setFieldName("");
      setFieldPrompt("");
      await fetchCustomFields();
      setFieldCreationSuccess(true);
      setTimeout(() => setFieldCreationSuccess(false), 5000);
      setSelectedTab("manage");
      setIsCustomFieldModalOpen(false);
    } catch (error) {
      console.error("Error adding field", error);
    } finally {
      setLoadingAddField(false);
    }
  };

  const handleSelectAll = () => {
    if (selectedContracts.length === contracts.length) {
      setSelectedContracts([]);
      setSelectedContractKeys([]);
    } else {
      setSelectedContracts(contracts.map((contract) => contract.id));
      setSelectedContractKeys(contracts.map((contract) => contract.key));
    }
  };

  const handleCheckboxChange = (id, key) => {
    if (selectedContracts.includes(id)) {
      setSelectedContracts(selectedContracts.filter((contractId) => contractId !== id));
      setSelectedContractKeys(selectedContractKeys.filter((contractKey) => contractKey !== key));
    } else {
      setSelectedContracts([...selectedContracts, id]);
      setSelectedContractKeys([...selectedContractKeys, key]);
    }
  };

  const filteredContracts = useMemo(() => {
    const query = searchQuery.toLowerCase().trim();
    if (!query) return contracts;
    return contracts.filter((contract) => {
      const contractName = contract.name?.toLowerCase() || "";
      const ownerName = contract.details?.["Client name"]?.toLowerCase() || "";
      const customerName = contract.details?.["Company Name"]?.toLowerCase() || "";
      return contractName.includes(query) || ownerName.includes(query) || customerName.includes(query);
    });
  }, [contracts, searchQuery]);

  const totalPages = useMemo(() => Math.ceil(filteredContracts.length / rowsPerPage), [filteredContracts, rowsPerPage]);

  const currentContracts = useMemo(() => {
    const indexOfLastContract = currentPage * rowsPerPage;
    const indexOfFirstContract = indexOfLastContract - rowsPerPage;
    return filteredContracts.slice(indexOfFirstContract, indexOfLastContract);
  }, [filteredContracts, currentPage, rowsPerPage]);

  const handleNextPage = () => { if (currentPage < totalPages) setCurrentPage(currentPage + 1); };
  const handlePreviousPage = () => { if (currentPage > 1) setCurrentPage(currentPage - 1); };

  const [actionMenuPosition, setActionMenuPosition] = useState({ top: 0, left: 0, openUpwards: false });

  const toggleActionMenu = (index, event) => {
    const menuHeight = 100;
    const rect = event.currentTarget.getBoundingClientRect();
    const bottomSpace = window.innerHeight - rect.bottom;
    const openUpwards = bottomSpace < menuHeight;
    setIsActionMenuOpen(isActionMenuOpen === index ? null : index);
    setActionMenuPosition({ top: openUpwards ? rect.top - menuHeight : rect.bottom + 6, left: rect.left - 130, openUpwards });
  };

  const enableEdit = (contract) => {
    if (contract) {
      setIsActionMenuOpen(false);
      setEditContractId(contract.id);
      setEditedContractData({ ...contract, details: { ...contract.details, _custom_fields: contract.details?._custom_fields || {} } });
    } else {
      setEditContractId(null);
      setEditedContractData({});
    }
  };

  const handleEditChange = (field, value) => {
    setEditedContractData((prev) => {
      if (field.startsWith("details._custom_fields.")) {
        const key = field.split(".")[2];
        return { ...prev, details: { ...prev.details, _custom_fields: { ...prev.details?._custom_fields, [key]: value } } };
      } else if (field.startsWith("details.")) {
        const key = field.split(".")[1];
        return { ...prev, details: { ...prev.details, [key]: value } };
      } else {
        return { ...prev, [field]: value };
      }
    });
  };

  const handleEditSave = async (contractId) => {
    try {
      const response = await api.post(`api/v1/contract/edit-contract-details/${editedContractData.key}/`, {
        edited_data: {
          "Client name": editedContractData.details?.["Client name"],
          "Company Name": editedContractData.details?.["Company Name"],
          "Effective Date": editedContractData.details?.["Effective Date"],
          "Renewal Date": editedContractData.details?.["Renewal Date"],
          "Expiration Date": editedContractData.details?.["Expiration Date"],
          _custom_fields: editedContractData.details?._custom_fields || {},
        },
        note: editedContractData.note || "",
        contract_name: editedContractData.name || "",
      });

      if (response.status === 200) {
        setContracts((prev) => prev.map((c) => c.id === contractId ? response.data : c));
        setEditContractId(null);
        setRenameSuccessRowId(contractId);
        setTimeout(() => setRenameSuccessRowId(null), 4000);
      }
    } catch (error) {
      showPopup("Error", "Failed to update contract. Please try again.");
    }
  };

  const handleDelete = (contractId) => {
    setIsActionMenuOpen(null);
    setIsBulkDelete(false);
    setContractToDelete(contractId);
    setConfirmDeleteVisible(true);
  };

  const handleBulkDelete = () => {
    if (!selectedContracts || selectedContracts.length === 0) return;
    setIsActionMenuOpen(null);
    setIsBulkDelete(true);
    setConfirmDeleteVisible(true);
  };

  const confirmDelete = async () => {
    const idsToDelete = isBulkDelete ? selectedContracts : [contractToDelete];
    setDeleteInProgress(true);
    try {
      const response = await api.delete(`api/v1/contract/delete-contract/`, { data: { contract_ids: idsToDelete } });
      const { Deleted_contracts = [] } = response.data;
      if (Deleted_contracts.length > 0) {
        setContracts((prev) => prev.filter((c) => !Deleted_contracts.includes(c.id)));
        if (isBulkDelete) {
          setSelectedContracts([]);
          setSelectedContractKeys([]);
        }
      }
    } catch (error) {
      showPopup("Error", "Failed to delete contract(s). Please try again.");
    } finally {
      setDeleteInProgress(false);
      setConfirmDeleteVisible(false);
      setContractToDelete(null);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString || dateString === "null") return "N/A";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "N/A";
    return `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
  };

  const toInputDateValue = (dateString) => {
    if (!dateString || dateString === "null") return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
  };

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files || []);
    if (selectedFiles.length === 0) return;
    setFile(selectedFiles);
    setIsModalOpen(true);
  };

  const handleViewMore = (contractKey, id) => {
    navigate(`/Contract/contract-details/${contractKey}`, { state: { id } });
  };

  const handleClickOutside = (event) => {
    if (isActionMenuOpen !== null && actionMenuRefs.current[isActionMenuOpen] && !actionMenuRefs.current[isActionMenuOpen].contains(event.target)) {
      setIsActionMenuOpen(null);
    }
    if (isActionMenuOpen === "more" && moreButtonRef.current && !moreButtonRef.current.contains(event.target)) {
      setIsActionMenuOpen(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isActionMenuOpen]);

  useEffect(() => {
    const calculateRowsPerPage = () => {
      if (tbodyRef.current) {
        const containerHeight = tbodyRef.current.clientHeight;
        const headerHeight = 52;
        const rowHeight = 44;
        const visibleHeight = containerHeight - headerHeight;
        const calculatedRows = Math.floor(visibleHeight / rowHeight);
        if (calculatedRows > 0) setRowsPerPage(calculatedRows);
      }
    };
    calculateRowsPerPage();
    window.addEventListener("resize", calculateRowsPerPage);
    return () => window.removeEventListener("resize", calculateRowsPerPage);
  }, []);

  const isAllChecked = selectedContracts.length === contracts.length && contracts.length > 0;

  return (
    <div className="flex flex-col flex-grow font-outfit max-w-full overflow-x-hidden">
      <div>
        <Header name="Contracts" icon={""} isMenuOpen={isMenuOpen} />
      </div>

      <div className="w-full mt-4 flex-grow px-2">
        {/* Top Action Bar */}
        <div className="flex justify-between items-center w-full px-4 mb-4">
          
          {/* Left: Search & Filter */}
          <div className="flex items-center gap-3 w-1/2">
            <div
              className={`flex w-[380px] h-[40px] px-4 py-2 items-center gap-2 rounded-[24px] bg-white transition-all duration-200 overflow-hidden ${
                isSearchFocused
                  ? "border border-[#BB42AE]/36 shadow-[0_11px_3px_transparent,0_7px_3px_rgba(0,0,0,0.01),0_4px_2px_rgba(0,0,0,0.05),0_2px_2px_rgba(0,0,0,0.09),0_0_1px_rgba(0,0,0,0.10)]"
                  : "border border-black/10"
              }`}
            >
              <img src="/search.svg" alt="Search" className="w-[18px] h-[18px] opacity-70" />
              <input
                type="text"
                placeholder="Search Contracts Here"
                className="font-outfit text-[14px] font-normal border-none outline-none w-full text-[#171717] bg-transparent whitespace-nowrap placeholder:text-gray-400"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onFocus={() => setIsSearchFocused(true)}
                onBlur={() => setIsSearchFocused(false)}
              />
            </div>

            <button
              className={`flex items-center justify-center gap-2 h-[40px] px-5 rounded-[24px] bg-white transition-all duration-200 ${
                isFilterApplied ? "border border-[#BB42AE]/36 shadow-sm" : "border border-black/10"
              }`}
              onClick={toggleFilterModal}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <path d="M5.85049 13.3333C5.61438 13.3333 5.41646 13.2535 5.25674 13.0938C5.09702 12.934 5.01716 12.7361 5.01716 12.5V7.5L0.183824 1.33333C-0.0245098 1.05556 -0.0557598 0.763889 0.0900735 0.458333C0.235907 0.152778 0.489379 0 0.85049 0H12.5172C12.8783 0 13.1317 0.152778 13.2776 0.458333C13.4234 0.763889 13.3922 1.05556 13.1838 1.33333L8.35049 7.5V12.5C8.35049 12.7361 8.27063 12.934 8.11091 13.0938C7.95118 13.2535 7.75327 13.3333 7.51716 13.3333H5.85049ZM6.68382 6.91667L10.8088 1.66667H2.55882L6.68382 6.91667Z" fill="#52525B"/>
</svg>
              <span className="font-outfit text-[#171717] text-[14px] font-medium">Filter</span>
            </button>
          </div>

          {/* Right SIDE ACTIONS */}
          <div className="flex items-center gap-3 flex-wrap justify-end">
            {selectedContracts.length > 0 ? (
              <>
                <span className="bg-[#F4EBFF] text-[#7F56D9] text-sm px-3 py-1.5 rounded-full font-medium border border-[#7F56D9]/20">
                  {selectedContracts.length} Contracts selected
                </span>

                <button
                  className="bg-[#7F56D9] text-white text-[14px] font-medium px-4 py-2 rounded-[8px] hover:bg-[#6941C6] transition-colors"
                  onClick={() => setIsCustomApplyFiledModal(true)}
                >
                  Apply Custom Field
                </button>

                <div className="relative inline-block">
                  <button
                    ref={moreButtonRef}
                    onClick={handleToggleMore}
                    className="border border-[#D0D5DD] text-[#344054] text-[14px] font-medium px-4 py-2 rounded-[8px] flex items-center gap-2 hover:bg-gray-50 transition-colors"
                  >
                    More
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path d="M19 9l-7 7-7-7" /></svg>
                  </button>

                  {isActionMenuOpen === "more" && (
                    <div
                      className="fixed z-[9999] w-36 bg-white border border-gray-200 rounded-[8px] shadow-lg p-1"
                      style={{ top: `${dropdownCoords.top}px`, left: `${dropdownCoords.left}px` }}
                    >
                      <button
                        onClick={handleExport}
                        disabled={exportInProgress}
                        className="flex items-center gap-2 px-3 py-2 text-[14px] rounded-[6px] w-full hover:bg-[#F8F3FF] text-[#C95EBE] transition-colors disabled:opacity-50"
                      >
                        <img src="/export-icon-blue.svg" className="w-4 h-4" />
                        {exportInProgress ? "Exporting..." : "Export"}
                      </button>
                      <button
                        onClick={handleBulkDelete}
                        className="flex items-center gap-2 px-3 py-2 mt-0.5 text-[14px] rounded-[6px] w-full hover:bg-red-50 text-red-600 transition-colors"
                      >
                        <img src="/delete-icon-red.svg" className="w-4 h-4" />
                        Delete
                      </button>
                    </div>
                  )}
                </div>

                <button onClick={handleCancel} className="flex items-center justify-center p-[8px] rounded-[8px] border border-black/10 bg-[#F4F4F5] hover:bg-[#E4E4E7] transition-colors ml-1">
                  <img src="/cancel_icon.svg" alt="Cancel" className="w-[16px] h-[16px]" />
                </button>
              </>
            ) : (
              <>
                <button
                    className="flex items-center gap-2 px-4 py-2 bg-white new-custom-butons-design"
                    onClick={() => setIsCustomFieldModalOpen(true)}
                  >
                    <img src="/custom-field-icons.svg" className="w-5 h-5" />
                    <span className="new-custom-butons-design-text">
                      Custom Field
                    </span>
                  </button>

                <div className="relative inline-block">
                  <button
                    ref={uploadButtonRef}
                    className="flex items-center justify-center gap-2 px-[22px] py-[9px] bg-[#C95EBE] rounded-[8px] text-white font-outfit text-[14px] font-medium hover:bg-[#b04b9e] transition-colors shadow-sm"
                    onClick={() => setIsTooltipVisible(!isTooltipVisible)}
                  >
                    <img src="/upload_icon_white.svg" className="w-[18px] h-[18px]" />
                    Upload Contract
                  </button>

                  {isTooltipVisible && (
                    <div className="absolute top-[115%] right-0 w-[188px] bg-white shadow-lg border border-gray-100 rounded-[12px] p-2 z-[1000] text-left">
                      <div
                        className="flex items-center gap-2 px-3 py-2 rounded-[8px] text-[#52525B] font-medium text-[14px] hover:bg-[#F8F3FF] hover:text-[#C95EBE] cursor-pointer transition-colors"
                        onClick={() => { setIsTooltipVisible(false); fileInputRef.current.click(); }}
                      >
                        <img src="/upload-icon.svg" alt="Upload" className="w-4 h-4" />
                        Add from device
                      </div>

                      {!isConnected ? (
                        <div
                          className="flex items-center gap-2 px-3 py-2 rounded-[8px] text-[#52525B] font-medium text-[14px] hover:bg-[#F8F3FF] hover:text-[#C95EBE] cursor-pointer transition-colors mt-1"
                          onClick={() => { setIsTooltipVisible(false); navigate("/account/integration"); }}
                        >
                          <img src="/connect-icon.svg" alt="Connect" className="w-4 h-4" />
                          Connect Drive
                        </div>
                      ) : (
                        <div
                          className="flex items-center gap-2 px-3 py-2 rounded-[8px] text-[#52525B] font-medium text-[14px] hover:bg-[#F8F3FF] hover:text-[#C95EBE] cursor-pointer transition-colors mt-1"
                          onClick={() => { setIsTooltipVisible(false); handleAddFromDriveClick(); }}
                        >
                          <img src="/picker-icon.svg" alt="Drive" className="w-4 h-4" />
                          Add from Drive
                        </div>
                      )}
                    </div>
                  )}

                  <input ref={fileInputRef} type="file" multiple className="hidden" accept=".pdf,.jpeg,.jpg,.png" onChange={handleFileChange} />
                </div>
              </>
            )}
          </div>
        </div>

        {/* Table UI */}
        <div className="w-full px-2 mt-2">
          <div className="relative overflow-auto custom-scrollbar w-full" style={{ height: "calc(100vh - 180px)" }} ref={tbodyRef}>
            <table className="w-full text-sm text-left table-auto border-separate border-spacing-0 min-w-max">
              <thead className="bg-white h-12 text-[#1E1E1E] font-medium">
                <tr>
                  <th className="w-[40px] px-3 sticky top-0 bg-white z-20 border-b border-black/10 align-middle text-center">
                    <input
                      type="checkbox"
                      style={{
                        appearance: "none",
                        border: "1.5px solid #c0c0c0",
                        borderRadius: "4px",
                        cursor: "pointer",
                        width: "18px",
                        height: "18px",
                        backgroundImage: isAllChecked ? "url('/checck.svg')" : "none",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "14px 14px",
                        display: "block",
                      }}
                      className="mx-auto"
                      onChange={handleSelectAll}
                      checked={isAllChecked}
                    />
                  </th>
                  <th className="min-w-[180px] px-3 py-3 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-20 border-b border-black/10">Contract Name</th>
                  <th className="min-w-[150px] px-3 py-3 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-20 border-b border-black/10">Party Involved (A)</th>
                  <th className="min-w-[150px] px-3 py-3 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-20 border-b border-black/10">Party Involved (B)</th>
                  <th className="min-w-[130px] px-3 py-3 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-20 border-b border-black/10">Effective Date</th>
                  
                  {customFields.map((field, index) => (
                    <th key={index} className="min-w-[150px] px-3 py-3 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-20 border-b border-black/10">
                      <span className="inline-flex items-baseline gap-1">
                        {field.field}
                        <img src="/invoice-bulblogo-invoicee.svg" alt="Hint" className="ml-1 w-3 h-3 translate-y-[-1px]" />
                      </span>
                    </th>
                  ))}
                  
                  <th className="min-w-[130px] px-3 py-3 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-20 border-b border-black/10">Renewal Date</th>
                  <th className="min-w-[130px] px-3 py-3 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-20 border-b border-black/10">Expiration Date</th>
                  <th className="w-[80px] px-3 py-3 align-middle text-center text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-20 border-b border-black/10">Actions</th>
                </tr>
              </thead>
              
              <tbody className="bg-white">
                {loading ? (
                  <tr>
                    <td colSpan={totalColumns + 1} className="py-20 border-b border-black/10">
                      <div className="text-center flex flex-col items-center justify-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#C95EBE] mx-auto mb-4"></div>
                        <p className="text-[#52525B] font-outfit text-[15px]">Loading Contracts...</p>
                      </div>
                    </td>
                  </tr>
                ) : contracts.length > 0 ? (
                  currentContracts.map((contract, index) => (
                    <tr
                      key={index}
                      ref={editContractId === contract.id ? editRowRef : null}
                      onMouseEnter={() => setHoveredRow(index)}
                      onMouseLeave={() => setHoveredRow(null)}
                      className={`h-[52px] border-b border-black/10 transition-colors ${hoveredRow === index ? "bg-[#F8F3FF] shadow-[0_2px_4px_rgba(0,0,0,0.05)]" : "bg-transparent"}`}
                    >
                      <td className="px-3 py-3 align-middle text-center border-b border-black/10">
                        <input
                          type="checkbox"
                          style={{
                            appearance: "none",
                            border: "1.5px solid #c0c0c0",
                            borderRadius: "4px",
                            cursor: "pointer",
                            width: "18px",
                            height: "18px",
                            backgroundImage: selectedContracts.includes(contract.id) ? "url('/checck.svg')" : "none",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "14px 14px",
                            display: "block",
                          }}
                          className="mx-auto"
                          checked={selectedContracts.includes(contract.id)}
                          onChange={() => handleCheckboxChange(contract.id, contract.key)}
                        />
                      </td>

                      {editContractId === contract.id ? (
                        <>
                          <td className="px-3 py-3 border-b border-black/10">
                            <input
                              type="text"
                              value={editedContractData.name || ""}
                              onChange={(e) => handleEditChange("name", e.target.value)}
                              className="w-full px-2 py-1 text-[13px] border border-gray-300 rounded focus:border-[#C95EBE] outline-none"
                              style={{ color: "#B793ED" }}
                            />
                          </td>
                          <td className="px-3 py-3 border-b border-black/10">
                            <input
                              type="text"
                              value={editedContractData.details?.["Client name"] || ""}
                              onChange={(e) => handleEditChange("details.Client name", e.target.value)}
                              className="w-full px-2 py-1 text-[13px] border border-gray-300 rounded focus:border-[#C95EBE] outline-none"
                            />
                          </td>
                          <td className="px-3 py-3 border-b border-black/10">
                            <input
                              type="text"
                              value={editedContractData.details?.["Company Name"] ?? contract.details?.["Company Name"] ?? ""}
                              onChange={(e) => handleEditChange("details.Company Name", e.target.value)}
                              className="w-full px-2 py-1 text-[13px] border border-gray-300 rounded focus:border-[#C95EBE] outline-none"
                            />
                          </td>
                          <td className="px-3 py-3 border-b border-black/10">
                            <input
                              type="date"
                              value={editedContractData.details?.["Effective Date"] ? toInputDateValue(editedContractData.details?.["Effective Date"]) : ""}
                              onChange={(e) => handleEditChange("details.Effective Date", e.target.value)}
                              className="w-full px-2 py-1 text-[13px] border border-gray-300 rounded focus:border-[#C95EBE] outline-none text-[#52525B]"
                            />
                          </td>

                          {customFields.map((fieldObj, i) => (
                            <td key={i} className="px-3 py-3 border-b border-black/10">
                              <input
                                type="text"
                                value={editedContractData.details?._custom_fields?.[fieldObj.field] || ""}
                                onChange={(e) => handleEditChange(`details._custom_fields.${fieldObj.field}`, e.target.value)}
                                className="w-full px-2 py-1 text-[13px] border border-gray-300 rounded focus:border-[#C95EBE] outline-none"
                              />
                            </td>
                          ))}

                          <td className="px-3 py-3 border-b border-black/10">
                            <input
                              type="date"
                              value={editedContractData.details?.["Renewal Date"] ? toInputDateValue(editedContractData.details?.["Renewal Date"]) : ""}
                              onChange={(e) => handleEditChange("details.Renewal Date", e.target.value)}
                              className="w-full px-2 py-1 text-[13px] border border-gray-300 rounded focus:border-[#C95EBE] outline-none text-[#52525B]"
                            />
                          </td>
                          <td className="px-3 py-3 border-b border-black/10">
                            <input
                              type="date"
                              value={editedContractData.details?.["Expiration Date"] ? toInputDateValue(editedContractData.details?.["Expiration Date"]) : ""}
                              onChange={(e) => handleEditChange("details.Expiration Date", e.target.value)}
                              className="w-full px-2 py-1 text-[13px] border border-gray-300 rounded focus:border-[#C95EBE] outline-none text-[#52525B]"
                            />
                          </td>
                          <td className="px-3 py-3 align-middle text-center border-b border-black/10">
                            <div className="flex items-center gap-2 justify-center">
                              <button onClick={() => handleEditSave(contract.id)} className="p-1.5 hover:bg-gray-100 rounded-full">
                                <img src="/save-icon-contracttable.svg" alt="Save" className="w-4 h-4" />
                              </button>
                              <button onClick={() => setEditContractId(null)} className="p-1.5 hover:bg-gray-100 rounded-full">
                                <img src="/cancel-icon-contracttable.svg" alt="Cancel" className="w-4 h-4" />
                              </button>
                            </div>
                          </td>
                        </>
                      ) : (
                        <>
                          <td className="px-3 py-3 align-middle border-b border-black/10 relative group">
                            <span
                              className="text-[#C95EBE] text-[14px] font-medium font-outfit border-b border-[#C95EBE] cursor-pointer hover:text-[#b04b9e]"
                              onClick={() => handleViewMore(contract.key, contract.id)}
                            >
                              {contract.name?.length > 30 ? `${contract.name.slice(0, 30)}...` : contract.name || "N/A"}
                            </span>
                            <div className="hidden group-hover:block absolute z-50 left-5 top-full mt-1 bg-[#333] text-white text-[12px] px-2 py-1 rounded whitespace-nowrap shadow-md">
                              {contract.name || "N/A"}
                            </div>

                            {renameSuccessRowId === contract.id && (
                              <div className="absolute left-10 top-2 z-10 flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-100 shadow-[0_4px_12px_rgba(0,0,0,0.1)] rounded-[8px] animate-[fadeIn_0.2s_ease-out]">
                                <img src="/green-icon-tick.svg" alt="Success" className="w-4 h-4" />
                                <span className="text-[#52525B] text-[13px] font-outfit whitespace-nowrap">Your changes were applied</span>
                              </div>
                            )}
                          </td>
                          <td className="px-3 py-3 align-middle text-[#52525B] font-outfit text-[14px] border-b border-black/10 relative group">
                            <span className="cursor-pointer">
                              {contract.details?.["Client name"]?.length > 25 ? `${contract.details["Client name"].slice(0, 20)}...` : contract.details?.["Client name"] || "N/A"}
                            </span>
                            <div className="hidden group-hover:block absolute z-50 left-5 top-full mt-1 bg-[#333] text-white text-[12px] px-2 py-1 rounded whitespace-nowrap shadow-md">
                              {contract.details?.["Client name"] || "N/A"}
                            </div>
                          </td>
                          <td className="px-3 py-3 align-middle text-[#52525B] font-outfit text-[14px] border-b border-black/10 relative group">
                            <span className="cursor-pointer">
                              {contract.details?.["Company Name"]?.length > 25 ? `${contract.details["Company Name"].slice(0, 20)}...` : contract.details?.["Company Name"] || "N/A"}
                            </span>
                            <div className="hidden group-hover:block absolute z-50 left-5 top-full mt-1 bg-[#333] text-white text-[12px] px-2 py-1 rounded whitespace-nowrap shadow-md">
                              {contract.details?.["Company Name"] || "N/A"}
                            </div>
                          </td>
                          <td className="px-3 py-3 align-middle text-[#52525B] font-outfit text-[14px] border-b border-black/10">
                            {formatDate(contract.details?.["Effective Date"])}
                          </td>

                          {customFields.map((fieldObj, i) => {
                            const fieldValue = contract.details?._custom_fields?.[fieldObj.field] || "N/A";
                            return (
                              <td key={i} className="px-3 py-3 align-middle border-b border-black/10">
                                <span
                                  className="text-[#C95EBE] cursor-pointer inline-block max-w-[140px] truncate text-[14px] font-outfit"
                                  onMouseEnter={(e) => {
                                    const rect = e.currentTarget.getBoundingClientRect();
                                    setCustomFieldPopup({ visible: true, value: fieldValue, contractKey: contract.key, contractId: contract.id, x: rect.left, y: rect.bottom + 8 });
                                  }}
                                  onMouseLeave={() => {
                                    setTimeout(() => { if (popupRef.current && !popupRef.current.matches(":hover")) setCustomFieldPopup((prev) => ({ ...prev, visible: false })); }, 150);
                                  }}
                                >
                                  {fieldValue.length > 15 ? `${fieldValue.slice(0, 15)}...` : fieldValue}
                                </span>
                              </td>
                            );
                          })}

                          <td className="px-3 py-3 align-middle text-[#52525B] font-outfit text-[14px] border-b border-black/10">
                            {formatDate(contract.details?.["Renewal Date"])}
                          </td>
                          <td className="px-3 py-3 align-middle text-[#52525B] font-outfit text-[14px] border-b border-black/10">
                            {formatDate(contract.details?.["Expiration Date"])}
                          </td>
                          <td className="px-3 py-3 align-middle text-center border-b border-black/10 relative">
                            <div
                              className="flex items-center justify-center w-8 h-8 mx-auto rounded-full hover:bg-gray-100 cursor-pointer transition-colors"
                              onClick={(e) => toggleActionMenu(index, e)}
                            >
                              <img src="/action.svg" alt="Actions" className="w-5 h-5" />
                            </div>
                            
                            {/* Row specific Action menu */}
                            {isActionMenuOpen === index && (
                              <div
                                className="fixed z-[9999] bg-white rounded-[12px] shadow-[0_4px_20px_rgba(0,0,0,0.12)] border border-gray-100 p-1.5 min-w-[120px] font-outfit"
                                ref={(el) => { if (el) actionMenuRefs.current[index] = el; }}
                                style={{
                                  top: `${actionMenuPosition.top}px`,
                                  left: `${actionMenuPosition.left - 130}px`,
                                }}
                              >
                                <div
                                  onClick={() => enableEdit(contract)}
                                  className="flex items-center gap-2.5 px-3 py-2 rounded-[8px] cursor-pointer text-[#52525B] hover:bg-[#FAF9F6] hover:text-[#C95EBE] transition-colors"
                                >
                                  <img src="/edit.svg" alt="Edit" className="w-4 h-4" />
                                  <span className="text-[14px] font-medium">Edit</span>
                                </div>
                                <div
                                  onClick={() => handleDelete(contract.id)}
                                  className="flex items-center gap-2.5 px-3 py-2 mt-0.5 rounded-[8px] cursor-pointer text-[#52525B] hover:bg-[#FFF0F0] hover:text-[#E21919] transition-colors"
                                >
                                  <img src="/delete.svg" alt="Delete" className="w-4 h-4" />
                                  <span className="text-[14px] font-medium">Delete</span>
                                </div>
                              </div>
                            )}
                          </td>
                        </>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={totalColumns + 1} className="py-16 text-center border-b border-black/10">
                      <div className="flex flex-col items-center justify-center">
                        <img src="/no-contracts.svg" alt="No Data" className="mx-auto mb-4 w-[120px] h-[120px]" />
                        <p className="text-[#52525B] font-outfit text-[15px]">Looks like your table is empty!</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          
          {/* Pagination */}
          {contracts.length > 0 && (
            <div className="flex items-center justify-start gap-4 mt-4 px-2 font-outfit text-[#52525B] text-[14px]">
              <div className="flex items-center justify-center px-3 py-1 bg-white border border-gray-200 rounded shadow-sm min-w-[32px]">
                {currentPage}
              </div>
              <p>of {totalPages} pages</p>
              <div className="flex gap-2">
                <button
                  onClick={handlePreviousPage}
                  disabled={currentPage === 1}
                  className="p-1.5 bg-white border border-gray-200 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors shadow-sm"
                >
                  <img src="/decrease.svg" alt="Previous" className="w-3 h-3" />
                </button>
                <button
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages}
                  className="p-1.5 bg-white border border-gray-200 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors shadow-sm"
                >
                  <img src="/increase.svg" alt="Next" className="w-3 h-3" />
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Global Modals */}
      {popupVisible && (
        <div className="fixed inset-0 z-[10000] bg-black/40 backdrop-blur-sm flex items-center justify-center">
          <div className="bg-white rounded-[12px] shadow-xl w-[440px] p-6 text-center font-outfit">
            <h2 className="text-[#171717] text-[18px] font-semibold mb-3">{popupTitle}</h2>
            <p className="text-[#52525B] text-[14px] leading-relaxed mb-6">{popupMessage}</p>
            <button className="bg-[#C95EBE] hover:bg-[#b04b9e] text-white text-[14px] font-medium px-6 py-2.5 rounded-[8px] transition-colors" onClick={closePopup}>
              Close
            </button>
          </div>
        </div>
      )}

      {confirmDeleteVisible && (
        <div className="fixed inset-0 z-[10000] bg-black/40 backdrop-blur-sm flex items-center justify-center">
          <div className="bg-white rounded-[12px] shadow-xl w-[440px] p-6 text-center animate-[fadeIn_0.2s_ease-out] font-outfit">
            <h2 className="text-[#171717] text-[18px] font-semibold mb-3">Are you sure you want to delete the selected contract(s)?</h2>
            <p className="text-[#52525B] text-[14px] leading-relaxed mb-6">
              Once deleted, the selected item(s) will be permanently removed. This action cannot be undone.
            </p>
            <div className="flex gap-3 justify-center">
              <button
                onClick={() => setConfirmDeleteVisible(false)}
                disabled={deleteInProgress}
                className="px-6 py-2.5 rounded-[8px] border border-gray-200 text-[#52525B] text-[14px] font-medium hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                disabled={deleteInProgress}
                className="px-6 py-2.5 rounded-[8px] bg-red-600 text-white text-[14px] font-medium hover:bg-red-700 transition-colors disabled:opacity-70"
              >
                {deleteInProgress ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}

      <UploadModal isOpen={isModalOpen} onClose={handleCloseModal} onUploadSuccess={handleUploadSuccess} type={"contract"} file={file} />

      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        token={token}
        setContracts={(filteredContracts) => {
          setContracts(filteredContracts);
          setIsFilterModalOpen(false);
          setIsFilterApplied(true);
        }}
        fetchContracts={fetchContracts}
        setIsFilterApplied={setIsFilterApplied}
      />

      {isCustomFieldModalOpen && (
        <div className="fixed inset-0 z-[10000] bg-black/40 backdrop-blur-sm flex items-center justify-center">
          <div className="bg-white w-[540px] rounded-[16px] shadow-2xl p-6 relative font-outfit flex flex-col">
            <button className="absolute top-4 right-5 text-gray-400 hover:text-gray-700 text-2xl font-light" onClick={() => setIsCustomFieldModalOpen(false)}>&times;</button>
            
            <h2 className="text-[20px] font-semibold text-[#171717] mb-1">Custom Fields</h2>
            <p className="text-[#52525B] text-[13px] leading-[18px] mb-5">
              You can only create up to 5 custom fields per document.<br />Deleting a field won't reset the limit.
            </p>

            <div className="flex gap-4 border-b border-gray-200 mb-6">
              <button
                className={`pb-2 text-[14px] font-medium border-b-2 transition-colors ${selectedTab === "manage" ? "border-[#C95EBE] text-[#C95EBE]" : "border-transparent text-[#73607B] hover:text-[#52525B]"}`}
                onClick={() => setSelectedTab("manage")}
              >
                {customFieldsLoading ? "Loading..." : `Manage Existing Fields (${customFields.length}/5)`}
              </button>
              <button
                className={`pb-2 text-[14px] font-medium border-b-2 transition-colors ${selectedTab === "create" ? "border-[#C95EBE] text-[#C95EBE]" : "border-transparent text-[#73607B] hover:text-[#52525B]"}`}
                onClick={() => setSelectedTab("create")}
              >
                Create New Field
              </button>
            </div>

            {selectedTab === "create" && (
              <div className="flex flex-col gap-4">
                <div>
                  <label className="flex items-center gap-1.5 text-[14px] font-medium text-[#171717] mb-1.5">
                    Field name <img src="/bulb.svg" alt="Hint" className="w-3.5 h-3.5" />
                  </label>
                  <input
                    type="text"
                    className="w-full border border-gray-300 rounded-[8px] px-3 py-2 text-[14px] outline-none focus:border-[#C95EBE] disabled:bg-gray-50 disabled:text-gray-400"
                    value={fieldName}
                    onChange={(e) => setFieldName(e.target.value)}
                    placeholder={isMaxFieldsReached ? "Maximum 5 fields allowed. Please delete one to add new." : "Enter your field name here"}
                    disabled={isMaxFieldsReached}
                  />
                </div>
                <div>
                  <label className="flex items-center gap-1.5 text-[14px] font-medium text-[#171717] mb-1.5">
                    Extraction Prompt <img src="/bulb.svg" alt="Hint" className="w-3.5 h-3.5" />
                  </label>
                  <textarea
                    className="w-full border border-gray-300 rounded-[8px] px-3 py-2 text-[14px] min-h-[100px] outline-none focus:border-[#C95EBE] resize-none disabled:bg-gray-50 disabled:text-gray-400"
                    value={fieldPrompt}
                    onChange={(e) => setFieldPrompt(e.target.value)}
                    placeholder={isMaxFieldsReached ? "Cannot enter prompt. Maximum limit reached." : "Enter your Extraction Prompts here"}
                    disabled={isMaxFieldsReached}
                  />
                </div>
                <div className="flex justify-end mt-2">
                  <button
                    className={`px-6 py-2 rounded-[8px] text-[14px] font-medium transition-colors ${isFilled && !loadingAddField && !isMaxFieldsReached ? "bg-[#C95EBE] text-white hover:bg-[#b04b9e]" : "bg-gray-200 text-gray-400 cursor-not-allowed"}`}
                    onClick={handleAddField}
                    disabled={loadingAddField || isMaxFieldsReached}
                  >
                    {loadingAddField ? "Adding..." : "Add Field"}
                  </button>
                </div>
              </div>
            )}

            {selectedTab === "manage" && (
              <div className="flex flex-col h-[280px]">
                <div className="flex gap-4 px-2 pb-2 text-[13px] font-semibold text-[#73607B]">
                  <div className="w-[120px]">Field Name</div>
                  <div className="flex-1">Prompt</div>
                  <div className="w-[80px]"></div>
                </div>
                
                <div className="flex-1 overflow-y-auto pr-2 custom-scrollbar space-y-4">
                  {customFields.length > 0 ? customFields.map((field, index) => (
                    <div key={index} className="flex gap-4 items-start border-b border-gray-100 pb-4">
                      <div className="w-[120px] text-[14px] font-medium text-[#171717] break-words mt-1">{field.field}</div>
                      <div className="flex-1 text-[13px] text-[#52525B] leading-snug mt-1">{field.description}</div>
                      <div className="w-[80px] text-right">
                        <button
                          className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-[6px] bg-[#FFF0F0] text-[#E21919] text-[12px] font-medium hover:bg-[#ffe5e5] transition-colors disabled:opacity-50"
                          onClick={() => { setDeletingField(field.id); handleDeleteField(field.id); }}
                          disabled={deletingField === field.id}
                        >
                          {deletingField === field.id ? "Deleting" : "Delete"}
                          <img src="/delete-icon-red.svg" alt="Delete" className="w-3 h-3" />
                        </button>
                      </div>
                    </div>
                  )) : (
                    <div className="text-center text-[14px] text-gray-500 py-10 italic">No custom fields available.</div>
                  )}
                </div>

                <div className="flex justify-end pt-4 border-t border-gray-100 mt-2">
                  <button
                    className="px-6 py-2 bg-[#C95EBE] text-white text-[14px] font-medium rounded-[8px] hover:bg-[#b04b9e] transition-colors"
                    onClick={async () => { await fetchContracts(); setIsCustomFieldModalOpen(false); }}
                  >
                    Done
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {fieldCreationSuccess && (
        <div className="fixed top-10 left-1/2 -translate-x-1/2 z-[11000] flex items-center gap-2 px-5 py-3 bg-white border border-green-100 shadow-[0_8px_30px_rgba(0,0,0,0.12)] rounded-[8px] animate-[slideDown_0.3s_ease-out]">
          <img src="/green-icon-tick.svg" className="w-5 h-5" alt="Success" />
          <span className="text-[#171717] text-[14px] font-medium font-outfit">Field Created successfully, Select documents to apply this field</span>
        </div>
      )}

      {isCustomApplyFieldModal && (
        <div className="fixed inset-0 z-[10000] bg-black/40 backdrop-blur-sm flex items-center justify-center">
          <div className="bg-white rounded-[16px] shadow-2xl w-[440px] p-6 relative font-outfit">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-[18px] font-semibold text-[#171717]">Apply Custom Field</h2>
              <div className="flex items-center gap-3">
                <span className="text-[#8B55DD] bg-[#8B55DD]/10 text-[13px] font-medium rounded-full px-3 py-1">
                  {selectedContracts.length} Contracts selected
                </span>
                <button onClick={() => setIsCustomApplyFiledModal(false)} className="text-gray-400 hover:text-gray-700 text-2xl font-light">&times;</button>
              </div>
            </div>

            <div className="flex gap-6 mb-6">
              <label className="flex items-center gap-2 cursor-pointer">
                <input type="radio" checked={!isCreatingNew} onChange={() => setIsCreatingNew(false)} className="w-4 h-4 accent-[#8B55DD]" />
                <span className="text-[14px] font-medium text-[#171717]">Select from Existing Field</span>
              </label>

              <label className="flex flex-col cursor-pointer">
                <div className="flex items-center gap-2">
                  <input type="radio" checked={isCreatingNew} onChange={() => setIsCreatingNew(true)} className="w-4 h-4 accent-[#8B55DD]" />
                  <span className="text-[14px] font-medium text-[#171717]">Create New Field</span>
                </div>
                <span className="text-[12px] text-gray-500 ml-6 mt-0.5">({customFields.length}/5 used)</span>
              </label>
            </div>

            {isCreatingNew ? (
              <div className="space-y-4">
                <div>
                  <label className="block text-[14px] font-medium text-[#171717] mb-1.5">Field Name</label>
                  <input
                    className="w-full px-3 py-2 border border-gray-300 rounded-[8px] text-[14px] outline-none focus:border-[#C95EBE]"
                    placeholder="Enter your field name here"
                    value={newFieldName}
                    onChange={(e) => setNewFieldName(e.target.value)}
                  />
                </div>
                <div>
                  <label className="block text-[14px] font-medium text-[#171717] mb-1.5">Extraction Prompt</label>
                  <textarea
                    className="w-full px-3 py-2 border border-gray-300 rounded-[8px] text-[14px] min-h-[80px] outline-none focus:border-[#C95EBE] resize-none"
                    placeholder="Enter your Extraction Prompts here"
                    value={newPrompt}
                    onChange={(e) => setNewPrompt(e.target.value)}
                  />
                </div>
              </div>
            ) : (
              <div>
                <label className="block text-[14px] font-medium text-[#171717] mb-1.5">Choose Field</label>
                <CustomDropdown selected={selectedField} onSelect={setSelectedField} options={customFields.map((field) => field.field)} />
              </div>
            )}

            <div className="flex justify-end gap-3 mt-8">
              <button
                className="px-5 py-2.5 rounded-[8px] border border-gray-200 text-[#52525B] text-[14px] font-medium hover:bg-gray-50 transition-colors"
                onClick={() => setIsCustomApplyFiledModal(false)}
              >
                Cancel
              </button>
              <button
                onClick={handleApplyField}
                disabled={isLoading}
                className="flex items-center justify-center min-w-[120px] px-5 py-2.5 rounded-[8px] bg-[#C95EBE] text-white text-[14px] font-medium hover:bg-[#b04b9e] transition-colors disabled:opacity-70"
              >
                {isLoading ? <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" /> : (isCreatingNew ? "Create & Apply" : "Apply Field")}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Floating custom field view-more popup outside table boundaries */}
      {customFieldPopup.visible && (
        <div
          ref={popupRef}
          className="fixed z-[11000] bg-white border border-gray-200 rounded-[8px] shadow-[0_4px_20px_rgba(0,0,0,0.15)] p-3.5 font-outfit animate-[fadeIn_0.1s_ease-out]"
          style={{ top: `${customFieldPopup.y}px`, left: `${customFieldPopup.x - 20}px`, maxWidth: "320px", width: "max-content", whiteSpace: "normal" }}
          onMouseEnter={() => setCustomFieldPopup((prev) => ({ ...prev, visible: true }))}
          onMouseLeave={() => setCustomFieldPopup((prev) => ({ ...prev, visible: false }))}
        >
          <p className="text-[#171717] text-[14px] font-medium break-words leading-relaxed">
            {customFieldPopup.value.length > 50 ? `${customFieldPopup.value.slice(0, 50)}...` : customFieldPopup.value}
          </p>
          <button
            onClick={() => handleViewMore(customFieldPopup.contractKey, customFieldPopup.contractId)}
            className="mt-2 text-[#C95EBE] text-[13px] font-medium hover:text-[#b04b9e] underline decoration-[#C95EBE]/30 hover:decoration-[#C95EBE] underline-offset-2 transition-all"
          >
            View Contract Details
          </button>
        </div>
      )}
    </div>
  );
};

export default ContractTable;
